// Source: This data was taken from the monolith database, table zocdoc.dbo.Procedure
export const PROCEDURE_IDS = {
    SIGNED_UP_FOR_ZOCDOC: '0',
    DENTAL_CLEANING: '11',
    DENTAL_CONSULTATION: '12',
    DENTAL_EMERGENCY: '13',
    FILLING: '14',
    ROOT_CANAL: '15',
    TEETH_WHITENING: '16',
    BRIDGE: '17',
    IMPLANTS: '18',
    DENTURES: '19',
    INVISIBLE_BRACES_CONSULTATION: '52',
    DENTIST_VENEERS: '66',
    GUM_SURGERY: '69',
    RETAINER_INSTALLATION: '70',
    ILLNESS: '75',
    ANNUAL_PHYSICAL: '76',
    PRESCRIPTION_REFILL: '77',
    PRE_TRAVEL_CHECKUP: '78',
    GENERAL_CONSULTATION: '83',
    DERMATOLOGY_CONSULTATION: '84',
    ANNUAL_SKIN_SCREENING: '85',
    ACNE: '86',
    PSORIASIS: '87',
    BOTOX_TREATMENT: '88',
    FILLER_TREATMENT: '89',
    HAIR_LOSS: '90',
    MOHS_SURGERY: '91',
    GENERAL_EYE_CONSULTATION: '92',
    EYEGLASSES: '98',
    CONTACT_LENSES: '99',
    EYE_INFECTION: '100',
    EYE_EMERGENCY_VISIT: '101',
    GLAUCOMA_CONSULTATION: '102',
    LASIK_SURGERY: '103',
    ORTHOPEDIC_CONSULTATION: '104',
    FOOT_PROBLEMS: '106',
    HAND_PROBLEMS: '109',
    ENT_CONSULTATION: '110',
    EAR_INFECTION: '111',
    HOARSENESS_VOICE_DISORDER: '113',
    HEARING_PROBLEMS_RINGING_IN_EARS: '114',
    VERTIGO: '115',
    SINUS_PROBLEMS: '116',
    SLEEP_PROBLEMS: '117',
    SWELLING_IN_NECK: '119',
    CANCER_SCREENING: '120',
    ELBOW_PROBLEMS: '121',
    BACK_PROBLEMS: '122',
    SPORT_INJURY: '123',
    KNEE_PROBLEMS: '124',
    HIP_PROBLEMS: '125',
    OB_GYN_CONSULTATION: '127',
    PREGNANCY: '128',
    BIRTH_CONTROL_CONTRACEPTION: '129',
    ANNUAL_PAP_SMEAR_GYN_EXAM: '130',
    SEXUAL_DYSFUNCTION_PAINFUL_SEX_DYSPAREUNIA: '132',
    OSTEOPOROSIS_EVALUATION: '133',
    FLU_SHOT: '134',
    CHILD_WITH_FEVER: '135',
    PEDIATRIC_CONSULTATION: '136',
    PRENATAL_FETAL_CONSULTATION: '137',
    THREE_TO_SEVEN_DAY_WELL_BABY_CHECKUP: '138',
    ONE_MONTH_WELL_BABY_CHECKUP: '139',
    TWO_MONTH_WELL_BABY_CHECKUP: '140',
    FOUR_MONTH_WELL_BABY_CHECKUP: '141',
    NINE_MONTH_WELL_BABY_CHECKUP: '142',
    TWELVE_MONTH_WELL_BABY_CHECKUP: '143',
    FIFTEEN_MONTH_WELL_BABY_CHECKUP: '144',
    EIGHTEEN_MONTH_WELL_BABY_CHECKUP: '145',
    TWENTY_FOUR_MONTH_WELL_BABY_CHECKUP: '146',
    THIRTY_MONTH_WELL_BABY_CHECKUP: '147',
    ANNUAL_PEDIATRIC_CHECKUP: '148',
    ULTRASOUND: '149',
    STD_SEXUALLY_TRANSMITTED_DISEASE: '150',
    ORTHODONTIC_CONSULTATION: '151',
    ORTHODONTIST_EMERGENCY_VISIT: '152',
    JAW_SURGERY: '156',
    ORTHODONTIST_VENEERS: '159',
    BRACES_RETAINER_CHECKUP: '160',
    SHOULDER_PROBLEM: '161',
    ALLERGY_CONSULTATION: '162',
    ALLERGIC_COUGH: '163',
    ALLERGIC_EYE_PROBLEMS: '164',
    ECZEMA: '166',
    FOOD_INTOLERANCE_ALLERGY: '168',
    DRUG_ALLERGY: '169',
    PSYCHIATRY_CONSULTATION: '171',
    MEDICATION_REVIEW: '172',
    PSYCHOTHERAPY: '173',
    BIPOLAR_DISORDER: '174',
    WORRY: '175',
    ALZHEIMERS_DISEASE: '176',
    ADDICTION_SUBSTANCE_ABUSE: '177',
    ADD_ADHD_HYPERACTIVE: '179',
    EATING_DISORDER: '180',
    SCHIZOPHRENIA_PSYCHOTIC_FEATURES: '181',
    TOOTH_EXTRACTION: '182',
    FOOT_CONSULTATION: '184',
    FOOT_INFECTION: '185',
    DIABETIC_FOOT: '186',
    FOOT_PAIN: '187',
    BUNION: '188',
    ANKLE_INJURIES_SPRAIN: '189',
    ARTHRITIS: '190',
    WARTS: '191',
    NAIL_PROBLEMS: '192',
    CARDIOLOGY_CONSULTATION: '193',
    CARDIOVASCULAR_SCREENING_VISIT: '194',
    CAROTID_DOPPLER: '195',
    ECHOCARDIOGRAM: '196',
    ECG_EKG: '197',
    HOLTER_MONITOR: '198',
    NUCLEAR_STRESS_TEST: '199',
    TREADMILL_STRESS_TEST: '200',
    CHOLESTEROL_LIPIDS_CHECKUP: '201',
    FAMILY_HISTORY_OF_HEART_ISSUES: '203',
    NOSE_PROBLEMS: '206',
    STENT_CONSULTATION: '207',
    HIGH_BLOOD_PRESSURE_HYPERTENSION: '208',
    PULMONOLOGY_CONSULTATION: '209',
    ASTHMA: '210',
    EMPHYSEMA: '213',
    PNEUMONIA: '214',
    LUNG_CANCER_SCREENING: '215',
    CYSTIC_FIBROSIS: '216',
    BRONCHOSCOPY: '217',
    PULMONARY_FUNCTION_TESTING: '218',
    THORACOSCOPY: '219',
    SLEEP_STUDIES: '221',
    DAYTIME_SLEEPINESS: '222',
    SLEEP_APNEA: '223',
    RESTLESS_LEGS_SYNDROME: '224',
    NEUROLOGY_CONSULTATION: '225',
    MIGRAINE: '226',
    WEAKNESS_PALSY: '227',
    TINGLING_NUMBNESS_WEAKNESS: '228',
    SEIZURES_EPILEPSY: '229',
    MOVEMENT_ISSUES: '232',
    STROKE_CHECK_UP_PREVENTION: '233',
    MULTIPLE_SCLEROSIS: '234',
    COGNITIVE_ISSUES: '236',
    EEG: '237',
    EMG_NCS: '238',
    CT_SCAN___LUNGS: '239',
    CT_SCAN___HEART_CORONARY_CTA: '240',
    CT_SCAN___HEAD: '241',
    CT_SCAN___TEETH_DENTAL_SCAN: '242',
    CT_SCAN___VIRTUAL_COLONOSCOPY: '243',
    CT_SCAN___WHOLE_BODY_SCAN: '244',
    CT_SCAN___OTHER: '245',
    MRI___BREAST: '247',
    MRI___BACK_SPINE: '248',
    MRI___OTHER: '249',
    PET_CT_SCAN: '250',
    X_RAY: '251',
    MAMMOGRAPHY___NO_BREAST_CANCER_HISTORY: '252',
    BONE_DENSITY_MEASUREMENT_DXA_SCAN: '255',
    SONOGRAPHY_ULTRASOUND: '256',
    PLASTIC_SURGERY_CONSULTATION: '349',
    HAND_SURGERY_CONSULTATION: '351',
    MICROVASCULAR_SURGERY: '353',
    HEAD_SURGERY_CONSULTATION: '355',
    THYROID_CONSULTATION: '356',
    SNORING: '357',
    NECK_SURGERY_CONSULTATION: '360',
    PRE_TRAVEL_CONSULTATION: '367',
    SECOND_OPINION: '368',
    DIABETES_CONSULTATION: '370',
    INFECTION_CONSULTATION: '371',
    SENIOR_VISIT: '372',
    ENDOCRINOLOGY_CONSULTATION: '373',
    ADRENAL_PROBLEMS: '375',
    ADRENOGENITAL_PROBLEMS: '376',
    GOITER: '377',
    THYROID_EVALUATION: '378',
    PROLACTINOMA_AND_OTHER_PITUITARY_PROBLEMS: '379',
    HEMATOLOGY_CONSULTATION: '380',
    ONCOLOGY_CONSULTATION: '383',
    ANEMIA: '384',
    LYMPHOMA: '385',
    GASTROENTEROLOGY_CONSULTATION: '386',
    NEPHROLOGY_CONSULTATION: '387',
    DIALYSIS: '388',
    COPD: '389',
    BRONCHITIS: '390',
    THORACENTESIS: '391',
    TMJ_TEMPORO_MANDIBULAR_JOINT_PAIN: '398',
    CROWN: '403',
    INLAYS: '404',
    PATHOLOGY_CONSULTATION: '405',
    ORAL_SURGERY_CONSULTATION: '406',
    DOUBLE_VISION: '410',
    SURGICAL_CONSULTATION: '412',
    CORNEA_PROBLEMS: '413',
    SURGERY: '415',
    BIOPSY: '416',
    NEUROSURGERY_CONSULTATION: '418',
    WRIST_PROBLEMS: '421',
    ANKLE_PROBLEMS: '422',
    RADIATION_ONCOLOGY_CONSULTATION: '425',
    RADIOLOGY_CONSULTATION: '426',
    UROLOGY_CONSULTATION: '427',
    MICROSURGERY: '429',
    PRE_SURGERY_CONSULTATION: '430',
    SKIN_GRAFTS: '431',
    SURGERY_CONSULTATION: '432',
    MRI___BRAIN: '433',
    BREAST_CORRECTION_AUGMENTATION_OR_REDUCTION: '434',
    BREAST_MICROSURGERY: '435',
    SWALLOWING_PROBLEMS: '436',
    MAXILLOFACIAL_SURGERY: '437',
    MICROBIOLOGY_EVALUATION: '438',
    PEDIATRIC_PRE_SURGERY_CONSULTATION: '439',
    PROSTHODONTIST_CONSULTATION: '440',
    FACE_RECONSTRUCTIVE_SURGERY_CONSULTATION: '441',
    ENT_ONCOLOGY_CONSULTATION: '442',
    NECK_ONCOLOGY_CONSULTATION: '443',
    PEDIATRIC_GENERAL_ENT_CONSULTATION: '444',
    NEURO_OPHTHALMOLOGY_CONSULTATION: '445',
    OCULAR_ONCOLOGY_CONSULTATION: '446',
    ORBITAL_DISEASE_CONSULTATION: '448',
    OCULOPLASTIC_SURGERY_CONSULTATION: '449',
    OPHTHALMOLOGIC_ELECTROPHYSIOLOGY_EVALUATION: '451',
    PEDIATRIC_EYE_CONSULTATION: '452',
    EYE_MISALIGNMENT_STRABISMUS: '453',
    VITREOUS_SURGERY_CONSULTATION: '454',
    RETINA_CONSULTATION_NON_SURGICAL: '455',
    OPHTHALMIC_PATHOLOGY_CONSULTATION: '457',
    RECONSTRUCTIVE_SURGERY_CONSULTATION: '458',
    RETINA_SURGERY_CONSULTATION: '461',
    EAR_PAIN: '463',
    SORE_THROAT: '466',
    FACIAL_COSMETIC_SURGERY_CONSULTATION: '467',
    DIZZINESS_VERTIGO: '468',
    FACE_SURGERY_CONSULTATION: '470',
    HEAD_ONCOLOGIST_CONSULTATION: '471',
    BRACES_CONSULTATION: '472',
    WISDOM_TOOTH_PROBLEM: '473',
    SICK_CHILD_VISIT: '478',
    ANTI_AGING_TREATMENT: '480',
    VAGINAL_DISCHARGE_INFECTION: '481',
    MENOPAUSE_CONSULTATION: '482',
    CORONARY_ANGIOGRAPHY: '483',
    AESTHETIC_SURGERY_CONSULTATION: '487',
    ATHLETES_FOOT: '490',
    WALKING_PROBLEMS: '491',
    FOOT_INJURIES: '492',
    DEPRESSION: '493',
    ANXIETY: '494',
    AUTISM: '496',
    MAMMOGRAPHY_WITH_BREAST_CANCER_HISTORY: '497',
    HEADACHE: '499',
    PARKINSONS_DISEASE: '500',
    DEMENTIA: '501',
    ALLERGIC_ASTHMA: '502',
    HAY_FEVER_SEASONAL_ALLERGIES: '503',
    RASH: '504',
    HIVES: '505',
    POISON_IVY_OR_POISON_OAK: '506',
    JAW_PAIN: '508',
    PRE_SURGERY_CHECKUP: '509',
    ENT_EMERGENCY_VISIT: '510',
    VISION_LOSS: '523',
    OPTIC_NERVE_INJURY: '524',
    PLASTIC_SURGERY: '525',
    UVEITIS_CONSULTATION: '527',
    VOICE_DISORDERS: '528',
    ASTIGMATISM: '529',
    CORNEAL_INJURY_INFECTION: '530',
    KERATITIS: '531',
    COCHLEAR_IMPLANT: '532',
    PAIN_MANAGEMENT_CONSULTATION: '535',
    CRANIOFACIAL_SURGERY_CONSULTATION: '540',
    NOSE_SURGERY_RHINOPLASTY: '541',
    FACIAL_WRINKLES_LINES: '542',
    EAR_DEFORMITY_AND_RECONSTRUCTION: '543',
    REFRACTIVE_SURGERY_CONSULTATION: '545',
    RENAL_FAILURE: '1001',
    CHRONIC_KIDNEY_DISEASE: '1002',
    BLOOD_IN_URINE_HEMATURIA: '1003',
    KIDNEY_STONES: '1004',
    URINARY_TRACT_INFECTION: '1005',
    PROTEIN_IN_URINE_PROTEINURIA: '1006',
    SPECT_SCAN: '1008',
    PET_SCAN: '1009',
    CHEMOTHERAPY: '1010',
    WEIGHT_LOSS: '1011',
    GYNECOLOGIC_ONCOLOGY_CONSULTATION: '1014',
    RADIOTHERAPY_CONSULTATION: '1015',
    PEDIATRIC_ONCOLOGY_CONSULTATION: '1016',
    INTERVENTIONAL_RADIOLOGY_TREATMENT: '1017',
    HIV_AIDS_CONSULTATION: '1018',
    FEVER: '1019',
    SEVERE_INFECTION: '1020',
    LUPUS_ERYTHEMATOSUS_SLE: '1021',
    SCLERODERMA: '1022',
    JOINT_PAIN: '1023',
    MUSCLE_PAIN: '1024',
    GOUT: '1025',
    VASCULITIS: '1026',
    INSOMNIA: '1027',
    NARCOLEPSY_EVALUATION: '1028',
    STOMACH_PAIN_ULCER: '1029',
    BLOOD_IN_STOOL: '1030',
    BLACK_STOOL_MELENA: '1031',
    ACID_REFLUX_HEARTBURN: '1032',
    COLON_CANCER_SCREENING: '1033',
    GASTROSCOPY: '1034',
    COLONOSCOPY: '1035',
    BREAST_CANCER_CHECKUP: '1036',
    OVARIAN_CANCER: '1037',
    UTERINE_CANCER_EVALUATION: '1038',
    CERVICAL_CANCER_EVALUATION: '1039',
    INCONTINENCE: '1040',
    UTERINE_VAGINAL_PROLAPSE: '1041',
    OBSESSIVE_COMPULSIVE_DISORDER: '1042',
    LEARNING_PROBLEMS: '1043',
    MENTAL_DEVELOPMENT_EVALUATION: '1044',
    BEDWETTING_INCONTINENCE: '1045',
    LANGUAGE_SPEECH_PROBLEMS: '1046',
    HEART_MURMUR_VALVE_DISORDER: '1047',
    CONGENITAL_HEART_DISEASE: '1048',
    HEART_RHYTHM_PROBLEM_PALPITATIONS_ARRHYTHMIA: '1049',
    STRESS_TEST: '1051',
    FAINTING_SYNCOPE: '1052',
    BYPASS_SURGERY_CABG_CONSULTATION: '1053',
    MINIMALLY_INVASIVE_BYPASS_OPCAB_CONSULTATION: '1054',
    HEART_VALVE_SURGERY_CONSULTATION: '1055',
    HEART_MALFORMATION_SURGERY_CONSULTATION: '1056',
    LAP_BAND_GASTRIC_BANDING_CONSULTATION: '1057',
    GASTRIC_BYPASS_CONSULTATION: '1058',
    GASTRIC_STIMULATOR_IMPLANTATION_CONSULTATION: '1059',
    WEIGHT_LOSS_CONSULTATION: '1060',
    INJURY_LACERATION: '1061',
    WOUND_CARE: '1062',
    ABDOMINAL_PAIN: '1063',
    LAPAROSCOPIC_SURGERY_CONSULTATION: '1064',
    HERNIA: '1065',
    ABSCESS: '1066',
    INFLAMMATORY_BOWEL_DISEASE: '1067',
    ULCERATIVE_COLITIS: '1068',
    CROHNS_DISEASE: '1069',
    DIVERTICULITIS_DIVERTICULOSIS: '1070',
    BLEEDING: '1071',
    HEMORRHOIDS: '1072',
    GALLBLADDER_REMOVAL_CHOLECYSTECTOMY: '1073',
    APPENDICITIS_APPENDECTOMY: '1074',
    BREAST_SURGERY: '1075',
    BREAST_BIOPSY: '1076',
    BREAST_CANCER_SURGERY: '1077',
    FRACTURE: '1078',
    TUMMY_TUCK_ABDOMINOPLASTY: '1079',
    EYELID_SURGERY_BLEPHAROPLASTY: '1080',
    BUTTOCK_CORRECTION_AUGMENTATION_OR_LIFT: '1081',
    CHEMICAL_PEEL: '1082',
    LABIAPLASTY_VAGINAL_CORRECTION: '1083',
    EAR_SURGERY_OTOPLASTY: '1084',
    FACELIFT: '1085',
    LIPOSUCTION: '1086',
    CHIN_CORRECTION: '1087',
    CHEEK_CORRECTION: '1088',
    LASER_SKIN_TREATMENT: '1089',
    CARPAL_TUNNEL_SYNDROME: '1090',
    WRIST_PAIN: '1091',
    TRIGGER_FINGER: '1092',
    HAND_INJURY_FRACTURE: '1093',
    TENNIS_ELBOW: '1094',
    GANGRENE: '1095',
    CRUSH_INJURY_TRAUMA: '1096',
    DECOMPRESSION_SICKNESS: '1097',
    BURN_INJURIES: '1098',
    INTRACRANIAL_ABSCESS: '1099',
    RADIATION_INJURY: '1100',
    AORTIC_ANEURYSM: '1101',
    ANEURYSM_NON_AORTIC: '1102',
    NARROWING_OF_INTESTINAL_ARTERIES: '1103',
    LEG_PAIN_WHILE_WALKING_PERIPHERAL_VASCULAR_DISEASE: '1104',
    FOOT_ULCERS: '1105',
    CAROTID_SURGERY: '1106',
    VEIN_THROMBOSIS_INFLAMMATION: '1107',
    VARICOSE_VEINS: '1108',
    LYMPHEDEMA: '1109',
    VASCULAR_SURGERY: '1110',
    ANGIOGRAPHY: '1111',
    EMBOLIZATION: '1112',
    DISSOLVE_BLOOD_CLOTS_THROMBOLYSIS: '1113',
    DRAIN_LINE_INSERTION: '1114',
    IVC_FILTER_INSERTION: '1115',
    CANCER_TREATMENT: '1116',
    DIARRHEA: '1117',
    NARROW_STOMACH_INTESTINE_PASSAGE: '1118',
    VOMITING: '1119',
    CONGENITAL_KIDNEY_DISEASE: '1120',
    KIDNEY_TRANSPLANT_CONSULTATION: '1121',
    BLOOD_THINNING_THERAPY_ANTICOAGULATION: '1122',
    BLEEDING_DISORDER: '1123',
    CLOTTING_DISORDERS: '1124',
    BLOOD_TRANSFUSION_CONSULTATION: '1125',
    BONE_MARROW_TRANSPLANT_CONSULTATION: '1126',
    SPLEEN_PROBLEMS: '1127',
    PREMATURE_BABY_CONSULTATION: '1128',
    JAUNDICE: '1129',
    NEONATOLOGIST_CONSULTATION: '1130',
    MENSTRUAL_PROBLEMS: '1131',
    EARLY_LATE_PUBERTY_ONSET: '1132',
    ADOLESCENT_MEDICINE_CONSULTATION: '1133',
    MUSCLE_DISORDERS_MYOPATHY: '1134',
    TICS_TOURETTE_SYNDROME: '1135',
    BRAIN_TUMOR_EVALUATION: '1136',
    HYDROCEPHALUS_BRAIN_MALFORMATION: '1137',
    MRI___SPINAL_CORD: '1138',
    CT_SCAN___SPINAL_CORD: '1139',
    MRI_ANGIOGRAPHY: '1140',
    CT_ANGIOGRAPHY: '1141',
    BRAIN_ANEURYSM_TREATMENT: '1142',
    FISTULA: '1143',
    STROKE_TREATMENT_ACUTE: '1144',
    EXTERNAL_BEAM_RADIOTHERAPY: '1145',
    STEREOTACTIC_RADIATION: '1146',
    NEUROBLASTOMA_TREATMENT: '1147',
    THYROID_CANCER: '1148',
    LIVER_CANCER: '1149',
    BONE_METASTASIS_TREATMENT: '1150',
    THREE_D_CONFORMAL_RADIOTHERAPY: '1151',
    LUNG_SURGERY_CONSULTATION: '1152',
    CHEST_WALL_SURGERY_CONSULTATION: '1153',
    DIAPHRAGM_SURGERY_CONSULTATION: '1154',
    CRITICAL_CARE_CONSULTATION: '1155',
    PAIN_MEDICINE_INJECTION: '1156',
    PAIN_MEDICATION_PRESCRIPTION: '1157',
    ANTI_PAIN_STIMULATOR_IMPLANTATION: '1158',
    ARRHYTHMIA_DIAGNOSTIC: '1159',
    ARRHYTHMIA___DRUG_THERAPY: '1160',
    PACEMAKER_IMPLANT: '1161',
    DEFIBRILLATOR_CHECKUP: '1162',
    SEDATION_DENTISTRY: '1163',
    JAW_CORRECTION: '1164',
    CHIROPRACTIC_CONSULTATION: '1165',
    PEDIATRIC_DENTIST_CONSULTATION: '1166',
    MILK_TOOTH_FILLING: '1167',
    CARIES_RISK_ASSESSMENT: '1168',
    THUMB_PACIFIER_HABIT_COUNSELING: '1169',
    PEDIATRIC_DENTAL_CLEANING: '1170',
    PERIODONTIST_CONSULTATION: '1171',
    TONSILLECTOMY_CONSULTATION: '1172',
    ADENOIDECTOMY_CONSULTATION: '1173',
    EMERGENCY_CONSULTATION: '1174',
    BRUISE_CONTUSION: '1175',
    MUSCLE_STRAIN: '1176',
    LIGAMENT_SPRAIN: '1177',
    TOXICOLOGY_CONSULTATION: '1178',
    BLOOD_SAMPLE: '1179',
    URINE_SAMPLE: '1180',
    HAIR_SAMPLE: '1181',
    OTHER_BODY_FLUID_SAMPLE: '1182',
    PEDIATRIC_ENDOCRINOLOGY_CONSULTATION: '1183',
    GROWTH_PROBLEMS: '1184',
    EPIDEMIOLOGY_CONSULTATION: '1185',
    VISUALLY_EVOKED_POTENTIALS: '1186',
    ELECTRORETINOGRAPHY_ERG: '1187',
    ELECTRO_OCULOGRAPHY_EOG: '1188',
    LAZY_EYE: '1189',
    HANGING_EYELID_PTOSIS: '1190',
    BLOCKED_TEAR_DUCT: '1191',
    REFRACTIVE_LENS_EXCHANGE: '1192',
    GENETICS_CONSULTATION: '1193',
    BIOCHEMICAL_GENETICS_CONSULTATION: '1194',
    MOLECULAR_GENETICS_CONSULTATION: '1195',
    IMMUNODEFICIENCY_CONSULTATION: '1196',
    AUTO_IMMUNE_DISORDER: '1197',
    MYASTHENIA_GRAVIS: '1198',
    HASHIMOTOS_DISEASE: '1199',
    TRANSPLANTATION_CONSULTATION: '1200',
    LIVER_TRANSPLANT_CONSULTATION: '1201',
    HEART_TRANSPLANT_CONSULTATION: '1202',
    HUNTINGTONS_DISEASE: '1203',
    HERNIATED_DISK: '1204',
    SPINAL_CORD_SURGERY: '1205',
    BRAIN_SURGERY: '1206',
    NUTRITION_CONSULTATION: '1207',
    EWINGS_SARCOMA: '1208',
    OSTEOSARCOMA: '1209',
    CHONDROSARCOMA: '1210',
    PEDIATRIC_ORTHOPEDICS_CONSULTATION: '1211',
    TORTICOLLIS_NECK_DEFORMATION: '1212',
    SPONDYLOLYSIS: '1213',
    SCOLIOSIS_SPINE_DEFORMATION: '1214',
    FOOT_DEFORMATION: '1215',
    CHEMICAL_PATHOLOGY_CONSULTATION: '1216',
    CYTOPATHOLOGY_CONSULTATION: '1217',
    FORENSIC_PATHOLOGY_CONSULTATION: '1218',
    NEUROPATHOLOGY_CONSULTATION: '1219',
    PEDIATRIC_PATHOLOGY_CONSULTATION: '1220',
    SKIN_PATHOLOGY_CONSULTATION: '1221',
    BLOOD_DONATION: '1222',
    STEM_CELL_COLLECTION: '1223',
    CLEFT_LIP: '1224',
    PEDIATRIC_SURGERY_CONSULTATION: '1225',
    NARROW_CLOSED_ESOPHAGUS: '1226',
    ABDOMINAL_WALL_SURGERY: '1227',
    CHILD_PSYCHIATRY_CONSULTATION: '1228',
    PEDIATRIC_HEMATOLOGY_CONSULTATION: '1229',
    THALASSEMIA: '1230',
    SICKLE_CELL_DISEASE: '1231',
    INFANT_RESPIRATORY_DISTRESS_SYNDROME: '1232',
    PNEUMOTHORAX: '1233',
    SPIROMETRY: '1234',
    PEDIATRIC_TRANSPLANT_CONSULTATION: '1235',
    UNDESCENDED_TESTES: '1236',
    PENIS_MALFORMATION: '1237',
    PEDIATRIC_UROLOGY_CONSULTATION: '1239',
    KIDNEY_BLADDER_CANCER: '1240',
    PHYSICAL_MEDICINE_REHAB_CONSULTATION: '1241',
    THERAPEUTIC_EXERCISE: '1242',
    WHEELCHAIR_CRUTCHES: '1243',
    PROSTHESIS: '1245',
    ALCOHOLISM: '1246',
    COMPETENCY_EVALUATION: '1247',
    MENTAL_STATE_OPINION: '1248',
    PUBLIC_HEALTH_CONSULTATION: '1249',
    MESENTERIC_ANGIOGRAPHY: '1250',
    BARIUM_SWALLOW: '1251',
    BENIGN_PROSTATIC_HYPERPLASIA: '1252',
    FREQUENT_URINATION: '1253',
    PROSTATE_CANCER: '1254',
    NEUROGENIC_BLADDER: '1255',
    ERECTILE_DYSFUNCTION_IMPOTENCE_MALE_SEXUAL_DYSFUNCTION: '1256',
    PREMATURE_EJACULATION: '1257',
    MALE_INFERTILITY: '1258',
    VASECTOMY_MALE_STERILIZATION: '1259',
    PHYSICAL_THERAPY_CONSULTATION: '1261',
    HEART_STRENGTHENING_RECOVERY: '1262',
    LUNG_STRENGTHENING_RECOVERY: '1263',
    MOBILITY_THERAPY: '1264',
    PAIN_REDUCTION_EXERCISE: '1265',
    POST_STROKE_NEUROLOGY_THERAPY: '1266',
    MOVEMENT_DISORDER_EXERCISES: '1267',
    POST_OPERATIVE_MOBILITY_JOINTS_AND_BODY: '1268',
    POST_OPERATIVE_MOBILITY_HAND_AND_FINGERS: '1269',
    PEDIATRIC_PHYSICAL_THERAPY: '1270',
    COGNITIVE_THERAPY: '1272',
    BEHAVIORAL_THERAPY: '1273',
    RELATIONSHIP_MARRIAGE_COUNSELING: '1274',
    SPORT_PERFORMANCE_COUNSELING: '1275',
    SEXUAL_ABUSE_COUNSELING: '1276',
    ADOLESCENT_TEEN_ISSUES: '1277',
    DIVORCE_COUNSELING: '1278',
    ANALYTICAL_THERAPY_PSYCHOANALYSIS: '1279',
    GROUP_THERAPY: '1280',
    PARENTING_COUNSELING: '1281',
    ANGER_MANAGEMENT: '1282',
    SEX_THERAPY_SEXUAL_DYSFUNCTION: '1283',
    IVF_REPRODUCTIVE_ENDOCRINOLOGY: '1284',
    HORMONE_LEVEL_MEASUREMENT: '1285',
    EXTRACTION_OF_EGGS: '1286',
    IMPLANTATION_OF_FERTILIZED_EGGS: '1287',
    TROPICAL_MEDICINE_CONSULTATION: '1288',
    TRAVEL_VACCINATIONS: '1289',
    ONCOLOGY_SURGERY: '1290',
    PREVENTIVE_MEDICINE_CONSULTATION: '1291',
    ARTHROSCOPY: '1292',
    IRRITABLE_BOWEL_SYNDROME: '1294',
    NEUROPSYCHOLOGY_EVALUATION: '1295',
    ACUPUNCTURE: '1296',
    SKULL_BASE_SURGERY: '1297',
    TMS: '1298',
    POLYMYALGIA_RHEUMATICA: '1299',
    GIANT_CELL_ARTERITIS: '1300',
    RHEUMATOID_ARTHRITIS: '1301',
    CARDIAC_CATHETERIZATION: '1303',
    MENINGIOMA: '1304',
    ACOUSTIC_NEUROMA: '1305',
    CHOLESTEATOMA: '1306',
    CATARACT: '1307',
    DENTAL_FOLLOW_UP: '1308',
    GENERAL_FOLLOW_UP: '1309',
    DERMATOLOGY_FOLLOW_UP: '1310',
    GENERAL_EYE_FOLLOW_UP: '1311',
    GLAUCOMA_FOLLOW_UP: '1312',
    ORTHOPEDIC_FOLLOW_UP: '1313',
    ENT_FOLLOW_UP: '1314',
    OB_GYN_FOLLOW_UP: '1315',
    PREGNANCY_FOLLOW_UP: '1316',
    PEDIATRIC_FOLLOW_UP: '1317',
    PRE_NATAL_FETAL_FOLLOW_UP: '1318',
    ORTHODONTIST_FOLLOW_UP: '1319',
    ALLERGY_FOLLOW_UP: '1320',
    PSYCHIATRY_FOLLOW_UP: '1321',
    FOOT_FOLLOW_UP: '1322',
    CARDIOLOGY_FOLLOW_UP: '1323',
    STENT_FOLLOW_UP: '1324',
    PULMONOLOGY_FOLLOW_UP: '1325',
    NEUROLOGY_FOLLOW_UP: '1326',
    PLASTIC_SURGERY_FOLLOW_UP: '1327',
    HAND_SURGERY_FOLLOW_UP: '1328',
    HEAD_SURGERY_FOLLOW_UP: '1329',
    NECK_SURGERY_FOLLOW_UP: '1330',
    PRE_TRAVEL_FOLLOW_UP: '1331',
    DIABETES_FOLLOW_UP: '1332',
    ENDOCRINOLOGY_FOLLOW_UP: '1333',
    HEMATOLOGY_FOLLOW_UP: '1334',
    ONCOLOGY_FOLLOW_UP: '1335',
    GASTROENTEROLOGY_FOLLOW_UP: '1336',
    NEPHROLOGY_FOLLOW_UP: '1337',
    PATHOLOGY_FOLLOW_UP: '1338',
    ORAL_SURGERY_FOLLOW_UP: '1339',
    SURGERY_FOLLOW_UP: '1341',
    NEUROSURGERY_FOLLOW_UP: '1342',
    RADIATION_ONCOLOGY_FOLLOW_UP: '1343',
    UROLOGY_FOLLOW_UP: '1344',
    PRE_SURGERY_FOLLOW_UP: '1345',
    SURGICAL_FOLLOW_UP: '1346',
    PEDIATRIC_PRE_SURGERY_FOLLOW_UP: '1347',
    PROSTHODONTIST_FOLLOW_UP: '1348',
    FACE_RECONSTRUCTIVE_SURGERY_FOLLOW_UP: '1349',
    ENT_ONCOLOGY_FOLLOW_UP: '1350',
    NECK_ONCOLOGY_FOLLOW_UP: '1351',
    PEDIATRIC_GENERAL_ENT_FOLLOW_UP: '1352',
    NEURO_OPHTHALMOLOGY_FOLLOW_UP: '1353',
    OCULAR_ONCOLOGY_FOLLOW_UP: '1354',
    ORBITAL_DISEASE_FOLLOW_UP: '1356',
    OCULOPLASTIC_SURGERY_FOLLOW_UP: '1357',
    PEDIATRIC_EYE_FOLLOW_UP: '1358',
    VITREOUS_SURGERY_FOLLOW_UP: '1359',
    RETINA_FOLLOW_UP_NON_SURGICAL: '1360',
    OPHTHALMIC_PATHOLOGY_FOLLOW_UP: '1361',
    RECONSTRUCTIVE_SURGERY_FOLLOW_UP: '1362',
    RETINA_SURGERY_FOLLOW_UP: '1363',
    FACIAL_COSMETIC_SURGERY_FOLLOW_UP: '1364',
    FACE_SURGERY_FOLLOW_UP: '1365',
    HEAD_ONCOLOGIST_FOLLOW_UP: '1366',
    MENOPAUSE_FOLLOW_UP: '1367',
    AESTHETIC_SURGERY_FOLLOW_UP: '1368',
    UVEITIS_FOLLOW_UP: '1369',
    PAIN_MEDICINE_FOLLOW_UP: '1370',
    CRANIOFACIAL_SURGERY_FOLLOW_UP: '1371',
    REFRACTIVE_SURGERY_FOLLOW_UP: '1372',
    GYNECOLOGIC_ONCOLOGY_FOLLOW_UP: '1374',
    RADIOTHERAPY_FOLLOW_UP: '1375',
    PEDIATRIC_ONCOLOGY_FOLLOW_UP: '1376',
    HIV_AIDS_FOLLOW_UP: '1377',
    BYPASS_SURGERY_CABG_FOLLOW_UP: '1379',
    MINIMALLY_INVASIVE_BYPASS_OPCAB_FOLLOW_UP: '1380',
    HEART_VALVE_SURGERY_FOLLOW_UP: '1381',
    HEART_MALFORMATION_SURGERY_FOLLOW_UP: '1382',
    LAP_BAND_GASTRIC_BANDING_FOLLOW_UP: '1383',
    GASTRIC_BYPASS_FOLLOW_UP: '1384',
    GASTRIC_STIMULATOR_IMPLANTATION_FOLLOW_UP: '1385',
    WEIGHT_LOSS_FOLLOW_UP: '1386',
    LAPAROSCOPIC_SURGERY_FOLLOW_UP: '1387',
    BREAST_SURGERY_FOLLOW_UP: '1388',
    VASCULAR_SURGERY_FOLLOW_UP: '1389',
    KIDNEY_TRANSPLANT_FOLLOW_UP: '1390',
    BLOOD_TRANSFUSION_FOLLOW_UP: '1391',
    BONE_MARROW_TRANSPLANT_FOLLOW_UP: '1392',
    PREMATURE_BABY_FOLLOW_UP: '1393',
    NEONATOLOGIST_FOLLOW_UP: '1394',
    ADOLESCENT_MEDICINE_FOLLOW_UP: '1395',
    CRITICAL_CARE_FOLLOW_UP: '1396',
    CHIROPRACTIC_FOLLOW_UP: '1397',
    PEDIATRIC_DENTIST_FOLLOW_UP: '1398',
    PERIODONTIST_FOLLOW_UP: '1399',
    TONSILLECTOMY_FOLLOW_UP: '1400',
    ADENOIDECTOMY_FOLLOW_UP: '1401',
    EMERGENCY_FOLLOW_UP: '1402',
    TOXICOLOGY_FOLLOW_UP: '1403',
    PEDIATRIC_ENDOCRINOLOGY_FOLLOW_UP: '1404',
    EPIDEMIOLOGY_FOLLOW_UP: '1405',
    GENETICS_FOLLOW_UP: '1406',
    BIOCHEMICAL_GENETICS_FOLLOW_UP: '1407',
    MOLECULAR_GENETICS_FOLLOW_UP: '1408',
    IMMUNODEFICIENCY_FOLLOW_UP: '1409',
    TRANSPLANTATION_FOLLOW_UP: '1410',
    LIVER_TRANSPLANT_FOLLOW_UP: '1411',
    HEART_TRANSPLANT_FOLLOW_UP: '1412',
    NUTRITION_FOLLOW_UP: '1413',
    PEDIATRIC_ORTHOPEDICS_FOLLOW_UP: '1414',
    CHEMICAL_PATHOLOGY_FOLLOW_UP: '1415',
    CYTOPATHOLOGY_FOLLOW_UP: '1416',
    FORENSIC_PATHOLOGY_FOLLOW_UP: '1417',
    NEUROPATHOLOGY_FOLLOW_UP: '1418',
    PEDIATRIC_PATHOLOGY_FOLLOW_UP: '1419',
    SKIN_PATHOLOGY_FOLLOW_UP: '1420',
    PEDIATRIC_SURGERY_FOLLOW_UP: '1421',
    CHILD_PSYCHIATRY_FOLLOW_UP: '1422',
    PEDIATRIC_HEMATOLOGY_FOLLOW_UP: '1423',
    PEDIATRIC_TRANSPLANT_FOLLOW_UP: '1424',
    PEDIATRIC_UROLOGY_FOLLOW_UP: '1425',
    PHYSICAL_MEDICINE_REHAB_FOLLOW_UP: '1426',
    PUBLIC_HEALTH_FOLLOW_UP: '1427',
    PHYSICAL_THERAPY_FOLLOW_UP: '1428',
    TROPICAL_MEDICINE_FOLLOW_UP: '1429',
    PREVENTIVE_MEDICINE_FOLLOW_UP: '1430',
    PANCREAS_PROBLEM: '1431',
    GALL_BLADDER_PROBLEM: '1432',
    BILIARY_TRACT_PROBLEM: '1433',
    HAIR_REMOVAL: '1434',
    PEDIATRIC_ALLERGY_CONSULTATION: '1435',
    PEDIATRIC_ALLERGY_FOLLOW_UP: '1436',
    PEDIATRIC_EMERGENCY: '1437',
    PALLIATIVE_CARE: '1438',
    NEURO_ONCOLOGY_CONSULTATION: '1439',
    NEUROLOGY_CRITICAL_CARE_CONSULTATION: '1440',
    OCCUPATIONAL_MEDICINE_CONSULTATION: '1441',
    PUBLIC_HEALTH_AND_GENERAL_PREVENTIVE_MEDICINE_CONSULTATION: '1442',
    ALLERGY_SHOTS: '1443',
    CALCIUM_CT_SCAN: '1444',
    LEG_VENOUS_DOPPLER: '1445',
    KG_ARTERIAL_DOPPLER: '1446',
    HEPATOLOGY_CONSULTATION: '1447',
    HEPATITIS: '1448',
    CIRRHOSIS: '1449',
    EPIDURAL_INJECTION: '1450',
    SPORT_NUTRITION_CONSULTATION: '1451',
    DIGESTIVE_PROBLEM: '1452',
    POLYCYSTIC_OVARY_SYNDROME_METABOLIC_SYNDROME: '1453',
    RECURRENT_PREGNANCY_LOSS: '1454',
    ENDOMETRIOSIS: '1455',
    PROSTATE_CANCER_SCREENING: '1456',
    DYSTONIA: '1457',
    ALS: '1458',
    NEUROSONOLOGY_CONSULTATION: '1459',
    PERIPHERAL_NEUROPATHY_CARPAL_TUNNEL: '1460',
    SPASTICITY: '1461',
    CONCUSSION: '1462',
    TILT_TABLE_TEST: '1463',
    INFECTIOUS_NEUROLOGY_CONSULTATION: '1465',
    FACIAL_PAIN: '1466',
    GYNECOLOGY_CONSULTATION: '1467',
    GYNECOLOGY_FOLLOW_UP: '1468',
    MYELOGRAM: '1469',
    ROSACEA: '1470',
    CHIROPRACTIC_ADJUSTMENT: '1471',
    CHIROPRACTIC_MASSAGE: '1472',
    ACUPUNCTURE_CHINESE_MEDICINE_CONSULTATION: '1473',
    ACUPRESSURE: '1474',
    MOXIBUSTION: '1475',
    CHINESE_MEDICINE_MASSAGE_TUI_NA: '1476',
    ACUPUNCTURE_CHINESE_MEDICINE_FOLLOW_UP: '1477',
    PEDIATRIC_DENTIST_EMERGENCY: '1478',
    BROKEN_TOOTH: '1479',
    DENTAL_CLEANING_PREVENTIVE_VISIT: '1480',
    ABDOMINAL_PELVIC_THERAPY: '1481',
    ADOLESCENT_ANNUAL_CHECK_UP: '1482',
    SPINAL_CORD_TUMOR: '1483',
    SPINAL_STENOSIS: '1484',
    SPINE_SPECIALIST_CONSULTATION: '1485',
    SPINE_SPECIALIST_FOLLOW_UP: '1486',
    SPORTS_MEDICINE_CONSULTATION: '1487',
    SPORTS_MEDICINE_FOLLOW_UP: '1488',
    SPORTS_PHYSICAL: '1489',
    STEREOTACTIC_BREAST_PROCEDURE: '1490',
    STOMACH_CANCER: '1491',
    EAR_WAX_CLEANING: '1492',
    STROKE_TRANSIENT_ISCHEMIC_ATTACK: '1493',
    STYE_HORDEOLUM: '1494',
    SURGERY_TO_IMPROVE_AGING_EYELIDS: '1495',
    ABORTION_SURGICAL: '1496',
    SURGERY_SECOND_OPINION: '1497',
    SYNCOPE_FAINTING: '1498',
    TAGGED_WHITE_CELL_STUDY: '1499',
    TEARING: '1500',
    TEEN_UNINTENDED_PREGNANCY: '1501',
    CERVICAL_POLYP: '1502',
    TENDONITIS: '1503',
    TESTICULAR_ABNORMALITY_CONGENITAL_OR_MASS: '1504',
    TESTICULAR_CANCER: '1505',
    THIGH_LIFT: '1506',
    THORACIC_SURGERY: '1507',
    THROAT_CANCER: '1508',
    THROMBOCYTOPENIA_LOW_PLATELETS: '1509',
    THROMBOCYTOSIS_HIGH_PLATELETS: '1510',
    THYROID_AND_PARATHYROID_SCANS: '1511',
    CHEEK_LIFT: '1512',
    THYROID_BIOPSY: '1513',
    THYROID_FOLLOW_UP: '1514',
    THYROID_NODULE: '1515',
    THYROID_OR_OTHER_HORMONAL_CANCER: '1516',
    THYROID_ULTRASOUND: '1517',
    THYROID_RELATED_EYELID_SOCKET_DISEASE: '1518',
    TIPS_BILIARY_INTERVENTIONS: '1519',
    TOENAIL_PROBLEM: '1520',
    TOENAIL_REMOVAL: '1521',
    TRACHEOSTOMY: '1522',
    TRANSCRANIAL_DOPPLER: '1523',
    TRAUMA: '1524',
    TRAUMA_SURGERY_CONSULTATION: '1525',
    TRAUMA_SURGERY_FOLLOW_UP: '1526',
    TRAUMATIC_BRAIN_INJURY: '1527',
    TRAVEL_MEDICINE_CONSULTATION: '1528',
    TRIGGER_POINT_INJECTION: '1529',
    TROPICAL_DISEASE_PARASITE_MALARIA: '1530',
    CHEST_PAIN: '1531',
    TUBAL_LIGATION_STERILIZATION: '1532',
    TUBE_PLACEMENT_OSTOMY: '1533',
    TUBERCULOSIS: '1534',
    NON_BACTERIAL_LUNG_INFECTION: '1535',
    TYPE_1_DIABETES: '1536',
    ULTRASOUND_THERAPY: '1537',
    UNWANTED_PREGNANCY: '1538',
    CHEST_WALL_SURGERY_FOLLOW_UP: '1539',
    UPPER_ARM_LIFT: '1540',
    URETHROCELE: '1541',
    URGENT_CARE_CONSULTATION: '1542',
    URGENT_CARE_FOLLOW_UP: '1543',
    URINARY_FISTULA: '1544',
    URINARY_INCONTINENCE: '1545',
    URODYNAMIC_STUDIES: '1546',
    UROGYNECOLOGY_CONSULTATION: '1547',
    UROGYNECOLOGY_FOLLOW_UP: '1548',
    UROLOGY_EMERGENCY: '1549',
    UROLOGY_PROBLEM: '1550',
    URTICARIA_AND_ANGIOEDEMA: '1551',
    VACCINES: '1552',
    VAGINAL_BLEEDING: '1553',
    VASCULAR_MALFORMATION: '1554',
    VASCULAR_NEUROLOGY_CONSULTATION: '1555',
    VASCULAR_NEUROLOGY_FOLLOW_UP: '1556',
    VENTILATION_PERFUSION_SCAN: '1557',
    VERTEBROPLASTY: '1558',
    VISUAL_AND_AUDITORY_IMPAIRMENT: '1559',
    VISUAL_PROBLEMS: '1560',
    VNG_VIDEO_NYSTAGMOGRAPHY: '1561',
    VULVAR_BIOPSY: '1562',
    WART_FREEZING: '1563',
    WEIGHT_LOSS_OPERATION: '1564',
    WELLNESS_MASSAGE: '1565',
    WORKERS_COMPENSATION_DISABILITY_EVALUATION: '1566',
    WRIST_ARTHROSCOPY: '1567',
    RIGHT_HEART_CATHETERIZATION: '1568',
    CONNECTIVE_TISSUE_DISORDER: '1569',
    ADVERSE_DRUG_REACTION: '1570',
    INTERSTITIAL_LUNG_DISEASE: '1571',
    PRE_CONCEPTION_COUNSELING: '1572',
    GRAVES_DISEASE: '1573',
    PYELONEPHRITIS: '1575',
    CERTIFIED_MEDICAL_EXAMINATION_FOR_PILOT: '1576',
    CERTIFIED_MEDICAL_EXAMINATION_FOR_COMMERCIAL_DRIVER_VESSEL_MASTER: '1577',
    CERTIFIED_MEDICAL_EXAMINATION_FOR_ATHLETE: '1578',
    CERTIFIED_MEDICAL_EXAMINATION_FOR_OVERSEAS_WORKER: '1579',
    CERTIFIED_MEDICAL_EXAMINATION_FOR_POLICE_OFFICER_FIREMAN: '1580',
    CHRONIC_PAIN: '1581',
    CLEFT_LIP_PALATE: '1582',
    COGNITIVE_OR_MEMORY_IMPAIRMENT_DEMENTIA: '1583',
    COLON_RECTAL_OR_ANAL_CANCER: '1584',
    COLON_CANCER: '1585',
    AGITATION: '1586',
    COLONIC_POLYP: '1587',
    COLORECTAL_SURGEON_CONSULTATION: '1588',
    COLORECTAL_SURGEON_FOLLOW_UP: '1589',
    COLORECTAL_SURGERY: '1590',
    COLPOSCOPY: '1591',
    COMPLETE_DENTURES: '1592',
    COMPLICATIONS_OF_GASTRIC_SURGERY: '1593',
    COMPLICATIONS_OF_PREGNANCY: '1594',
    COMPREHENSIVE_DILATED_EYE_EXAM: '1595',
    AIR_GAS_EMBOLISM: '1596',
    CONGENITAL_ANOMALY: '1597',
    CONGENITAL_ORTHOPEDIC_PROBLEM: '1598',
    CONGESTIVE_HEART_FAILURE: '1599',
    CONSTIPATION: '1600',
    CONTRACTURES: '1601',
    CORNEAL_SPECIALIST_CONSULTATION: '1602',
    CORNEAL_SPECIALIST_FOLLOW_UP: '1603',
    ALCOHOLIC_LIVER_DISEASE: '1604',
    CORNS_CALLUSES: '1605',
    CORONARY_ARTERY_DISEASE: '1606',
    COSMETIC_DENTIST_CONSULTATION: '1607',
    COSMETIC_DENTIST_EMERGENCY: '1608',
    COSMETIC_DENTIST_FOLLOW_UP: '1609',
    COSMETIC_DERMATOLOGY_CONSULTATION: '1610',
    COSMETIC_DERMATOLOGY_FOLLOW_UP: '1611',
    CRACKED_TOOTH_REPAIR: '1612',
    ALLERGIC_ARTHRITIS: '1613',
    CRUTCHES_WHEELCHAIR: '1614',
    CT_SCAN___ABDOMINAL_PELVIC: '1615',
    CT_SCAN___CHEST: '1616',
    CYSTOCELE: '1617',
    CYSTOSCOPY: '1618',
    CYSTS: '1619',
    D_AND_C_VACUUM_ASPIRATION: '1620',
    DECREASED_VISION: '1621',
    ALLERGY_TESTING: '1622',
    DEGENERATIVE_DISEASE: '1623',
    DEHYDRATION_NUTRITION_ISSUES: '1624',
    DELIRIUM: '1625',
    DENTAL_PAIN_CONSULTATION: '1626',
    DENTAL_PAIN_EMERGENCY_VISIT: '1627',
    DENTAL_PAIN_FOLLOW_UP: '1628',
    DENTAL_PALLIATIVE_CARE: '1629',
    DENTURE_REPAIR: '1630',
    DERMATOLOGY_SURGERY: '1631',
    AMPUTEE_CARE: '1632',
    DERMATOMYOSITIS: '1633',
    DEVELOPMENT_DISORDER: '1634',
    DEVELOPMENTAL_PEDIATRIC_CONSULTATION: '1635',
    DEVELOPMENTAL_PEDIATRIC_FOLLOW_UP: '1636',
    DIABETIC_NEPHROPATHY: '1637',
    DIABETIC_RETINOPATHY: '1638',
    ANAL_FISSURE: '1639',
    DIALYSIS_CATHETER_PLACEMENT: '1640',
    DIAPHRAGM_SURGERY_FOLLOW_UP: '1641',
    DISABILITY_EVALUATION: '1642',
    DISSOCIATIVE_DISORDER_ADJUSTMENT_DISORDER: '1643',
    DRAIN: '1644',
    DRAINAGE_OF_ABSCESS: '1645',
    DRY_EYE: '1646',
    ANAPHYLAXIS_ALLERGY: '1647',
    EAR_NOSE_THROAT_INCLUDES_LARYNX_CANCER: '1648',
    EAR_SURGERY_CONSULTATION: '1649',
    EAR_SURGERY_FOLLOW_UP: '1650',
    EAR_TUBES: '1651',
    EAR_NOSE_OR_THROAT_PROBLEM: '1652',
    ECTOPIC_TUBAL_PREGNANCY: '1653',
    ABDOMINAL_NUCLEAR_MEDICINE_STUDY: '1654',
    ANESTHESIA_CONSULTATION: '1655',
    ECTROPION_ECTROPION_REPAIR: '1656',
    ELEVATED_CREATININE_ACUTE_RENAL_FAILURE: '1657',
    EMBRYO_TRANSFER_INTRAUTERINE: '1658',
    EMERGENCY_MEDICINE_CONSULTATION: '1659',
    ENDOCARDITIS: '1660',
    ENDOMETRIAL_BIOPSY: '1661',
    ENDOMETRIAL_CANCER: '1662',
    ENDOSCOPIC_EYEBROW_ELEVATION: '1663',
    ANIMAL_ALLERGIES: '1664',
    ENDOSCOPY: '1665',
    ENDOVENOUS_LASER_TREATMENT_OF_VARICOSE_VEINS: '1666',
    ENLARGED_PROSTATE_BPH: '1667',
    EPILEPSY_SEIZURE_DISORDER: '1668',
    ESOPHAGEAL_CANCER: '1669',
    EVALUATION_OF_KIDNEY_MASS: '1670',
    EVOKED_POTENTIAL_TESTING: '1671',
    EXCISION_OF_CYST: '1672',
    ANKYLOSING_SPONDYLITIS: '1673',
    EXPERT_WITNESS: '1674',
    EYE_CANCER: '1675',
    EYE_SURGERY_CONSULTATION: '1676',
    EYE_SURGERY_FOLLOW_UP: '1677',
    EYE_TRAUMA_REMOVAL_OF_FOREIGN_BODY_CORNEAL_ABRASION: '1678',
    EYE_TUMOR: '1679',
    EYELID_AND_EYEBROW_SURGERY_CONSULTATION: '1680',
    EYELID_AND_EYEBROW_SURGERY_FOLLOW_UP: '1681',
    EYELID_CANCER: '1682',
    ANOPHTHALMIA: '1683',
    EYELID_MALPOSITION: '1684',
    EYELID_PROBLEM: '1685',
    FACIAL_IMPLANTS: '1686',
    FACIAL_PAIN_OR_TIC_TRIGEMINAL_NEURALGIA: '1687',
    FACIAL_PROSTHETIC_DEVICE: '1688',
    FACIAL_RECONSTRUCTIVE_SURGERY_CONSULTATION: '1689',
    ANTICOAGULATION_MANAGEMENT: '1690',
    FACIAL_RECONSTRUCTIVE_SURGERY_FOLLOW_UP: '1691',
    FALL: '1692',
    FAT_GRAFTING: '1693',
    FDG_GLUCOSE_METABOLIC_IMAGING: '1694',
    FECAL_INCONTINENCE: '1695',
    FEEDING_TUBE_PLACEMENT: '1696',
    FETAL_HEART_MONITORING: '1697',
    FIBROCYSTIC_BREAST_DISEASE: '1698',
    FIBROIDS: '1699',
    AORTIC_DISEASE: '1700',
    FIBROMYALGIA: '1701',
    FINGERNAIL_PROBLEM: '1702',
    FITTING_FOR_HEARING_AIDS: '1703',
    FLASHERS_AND_FLOATERS: '1704',
    FLU: '1705',
    FLUOROSCOPY: '1706',
    FOOT_AND_ANKLE_INFECTIONS: '1707',
    APHERESIS: '1708',
    FOOT_AND_ANKLE_SPECIALIST_CONSULTATION: '1709',
    FOOT_AND_ANKLE_SPECIALIST_FOLLOW_UP: '1710',
    FOOT_OR_ANKLE_FRACTURE: '1711',
    FOOT_OR_ANKLE_PAIN: '1712',
    FOOT_OR_ANKLE_TUMOR_NEUROMA: '1713',
    FOREHEAD_CORRECTION: '1714',
    FREEZING_OF_GYNECOLOGIC_WARTS: '1715',
    FREEZING_OF_WARTS: '1716',
    ARM_PAIN: '1717',
    FUNGAL_INFECTION: '1718',
    GALLSTONES: '1719',
    GALLSTONES_AND_CHOLECYSTITIS: '1720',
    GASTRIC_EMPTYING_SCAN: '1721',
    GASTROENTEROLOGY_EMERGENCY: '1722',
    GASTROINTESTINAL_PROBLEM: '1723',
    ARTERIAL_DOPPLER: '1724',
    GENETIC_COUNSELING_PREGNANCY_SCREENING: '1725',
    GERIATRIC_MEDICINE: '1726',
    GERIATRIC_MEDICINE_CONSULTATION: '1727',
    GERIATRIC_MEDICINE_FOLLOW_UP: '1728',
    GYNECOLOGIC_BIOPSY: '1729',
    GYNECOLOGIC_CANCER: '1730',
    GYNECOLOGIC_ONCOLOGY_OVARY_UTERUS_CERVIX_TUBES: '1731',
    ARTIFICIAL_EYE: '1732',
    GYNECOLOGY_EMERGENCY: '1733',
    GYNECOLOGY_PROBLEM: '1734',
    HAIR_REPLACEMENT_SURGERY: '1735',
    HAMMERTOES: '1736',
    HAND_MICROSURGERY_SPECIALIST_CONSULTATION: '1737',
    HAND_MICROSURGERY_SPECIALIST_FOLLOW_UP: '1738',
    ABDOMINAL_SURGERY: '1739',
    ARTIFICIAL_INSEMINATION_INTRA_UTERINE: '1740',
    HAND_SKIN_PROBLEM_WARTS: '1741',
    HEAD_NECK_SURGERY: '1742',
    HEAD_INJURY: '1743',
    HEARING_LOSS: '1744',
    HEART_DISEASE_IN_PREGNANCY: '1745',
    HEART_FAILURE_TRANSPLANT_CONSULTATION: '1746',
    HEART_FAILURE_TRANSPLANT_FOLLOW_UP: '1747',
    ARTIFICIAL_NOSE: '1748',
    HEART_PROBLEM: '1749',
    HEART_TRANSPLANT: '1750',
    HEAVY_OR_IRREGULAR_VAGINAL_BLEEDING: '1751',
    HEEL_PAIN: '1752',
    HEMOLYTIC_DISEASES_OF_NEWBORN: '1753',
    HEPATITIS_B: '1754',
    HEPATITIS_C: '1755',
    HEPATOBILIARY_IMAGING: '1756',
    ASCITES_EXTRA_FLUID_IN_GUT: '1757',
    HEPATOLOGY_FOLLOW_UP: '1758',
    HERBAL_MEDICINE_CONSULTATION: '1759',
    HIGH_CHOLESTEROL_LIPID_PROBLEM: '1760',
    HIP_PAIN: '1761',
    HIV_AIDS: '1762',
    HIV_RELATED_CANCER: '1763',
    HOME_SAFETY_EVALUATION: '1764',
    HOMEOPATHY_CONSULTATION: '1765',
    HOSPICE_AND_PALLIATIVE_MEDICINE_CONSULTATION: '1766',
    ATELECTASIS_COLLAPSE_OF_LUNG: '1767',
    HOSPICE_AND_PALLIATIVE_MEDICINE_FOLLOW_UP: '1768',
    HOSPITALIST_CONSULTATION: '1769',
    HYDROCELE_SPERMATOCELE: '1770',
    HYPERBARIC_TREATMENT_SPECIALIST_CONSULTATION: '1771',
    HYPERBARIC_TREATMENT_SPECIALIST_FOLLOW_UP: '1772',
    HYPERTHYROIDISM_OVERACTIVE_THYROID: '1773',
    HYPOTHYROIDISM_UNDERACTIVE_THYROID: '1774',
    ATRIAL_FIBRILLATION: '1775',
    HYSTEROSALPINGOGRAM: '1776',
    IMMOBILITY: '1777',
    IMMUNODEFICIENCY: '1778',
    IMPAIRED_GAIT: '1779',
    IMPAIRED_VISION: '1780',
    INFECTION_FOLLOW_UP: '1781',
    INFECTIOUS_DISEASE_PROBLEM: '1782',
    AUDIOLOGY_CONSULTATION: '1783',
    INFERTILITY_CONSULTATION: '1784',
    INFERTILITY_FOLLOW_UP: '1785',
    INSECT_BITES: '1786',
    INSTALL_BRACES: '1787',
    INSTALL_INVISALIGN: '1788',
    INSTALL_RETAINERS: '1789',
    INTERSTITIAL_CYSTITIS_BLADDER_PAIN: '1790',
    INTRAOPERATIVE_MONITORING: '1791',
    INTRAUTERINE_INSEMINATION: '1792',
    AUDIOLOGY_FOLLOW_UP: '1793',
    IODINE_TREATMENT: '1794',
    IRREGULAR_MENSTRUATION: '1795',
    ITCHING: '1796',
    IUD_INSERTION: '1797',
    IVF_COUNSELING: '1798',
    JOINT_ASPIRATION: '1799',
    JOINT_INJECTION: '1800',
    JOINT_PROBLEM: '1801',
    JUVENILE_ARTHRITIS: '1802',
    AUTOIMMUNE_LIVER_DISEASE: '1803',
    JUVENILE_DIABETES: '1804',
    JUVENILE_RHEUMATOID_ARTHRITIS: '1805',
    KIDNEY_AND_URINARY_PERFUSION_SCAN: '1806',
    KIDNEY_BIOPSY: '1807',
    KIDNEY_CANCER: '1808',
    KIDNEY_PROBLEM: '1809',
    KIDNEY_TRANSPLANT: '1810',
    KIDNEY_ULTRASOUND: '1811',
    BACK_PAIN: '1812',
    LACTATIONAL_PROBLEMS: '1813',
    LAMBERT_EATON_MYASTHENIC_SYNDROME: '1814',
    LARYNGOLOGIST_CONSULTATION: '1815',
    LARYNGOLOGIST_FOLLOW_UP: '1816',
    LARYNGOSCOPY: '1817',
    LASER_ASSISTED_NEW_ATTACHMENT_PROCEDURE_LANAP: '1818',
    BALLOON_ANGIOPLASTY_STENT: '1819',
    LASER_HAIR_REMOVAL: '1820',
    LASER_TOENAIL_TREATMENT: '1821',
    LEG_PAIN: '1822',
    LEG_PROBLEM: '1823',
    LEUKEMIA: '1824',
    LEUKOCYTOSIS_HIGH_WHITE_BLOOD_COUNT: '1825',
    LEUKOPENIA_LOW_WHITE_BLOOD_COUNT: '1826',
    LINE_INSERTION: '1827',
    ABNORMAL_PAP_SMEAR_COLPOSCOPY_LEEP_PROCEDURE: '1828',
    LIVER_BIOPSY: '1829',
    LUMBAR_PUNCTURE: '1830',
    LUNELLE_REMOVAL: '1831',
    LUNG_CANCER: '1832',
    LUNG_PROBLEM: '1833',
    LUNG_SURGERY_FOLLOW_UP: '1834',
    LUNG_TRANSPLANT_CONSULTATION: '1835',
    LUNG_TRANSPLANT_FOLLOW_UP: '1836',
    LYME_DISEASE: '1837',
    BEHAVIORAL_PEDIATRIC_CONSULTATION: '1838',
    MACULAR_DEGENERATION: '1839',
    MASSAGE_THERAPY: '1840',
    MASSAGE_THERAPY_CONSULTATION: '1841',
    MASSAGE_THERAPY_FOLLOW_UP: '1842',
    MASTITIS_PAINFUL_NIPPLES_WITH_BREASTFEEDING: '1843',
    MATERNAL_FETAL_MEDICINE_CONSULTATION: '1844',
    MATERNAL_FETAL_MEDICINE_FOLLOW_UP: '1845',
    MAXILLOFACIAL_BIRTH_DEFECT: '1846',
    BEHAVIORAL_PEDIATRIC_FOLLOW_UP: '1847',
    MAXILLOFACIAL_CANCER: '1848',
    MAXILLOFACIAL_PROSTHETIC_DEVICE: '1849',
    MAXILLOFACIAL_TRAUMA: '1850',
    ABORTION_MEDICAL: '1851',
    MELANOMA_AND_OTHER_SKIN_CANCERS: '1852',
    MENINGITIS: '1853',
    MENOPAUSE: '1854',
    MENTAL_HEALTH_CONSULTATION: '1855',
    MENTAL_HEALTH_PROBLEM: '1856',
    MENTAL_RETARDATION: '1857',
    BENIGN_MUSCULOSKELETAL_TUMOR: '1858',
    MESENTERIC_ISCHEMIA: '1859',
    METABOLIC_LIVER_DISEASE: '1860',
    METASTATIC_CANCER_OF_UNKNOWN_PRIMARY: '1861',
    METASTATIC_DISEASE: '1862',
    MIDWIFERY_CONSULTATION: '1863',
    MISCARRIAGE: '1864',
    MISCARRIAGE_MANAGEMENT_BY_VACUUM_ASPIRATION: '1865',
    MOVEMENT_DISORDER_TREMOR: '1866',
    BENIGN_NEOPLASM: '1867',
    MRI___ABDOMEN_PELVIS: '1868',
    MRI___HEAD: '1869',
    MRI___KNEE: '1870',
    MRI___SHOULDER: '1871',
    MULTIPLE_GESTATION_TWINS_OR_TRIPLETS: '1872',
    MULTIPLE_MYELOMA: '1873',
    BEREAVEMENT_GRIEF_COUNSELING: '1874',
    MUSCULOSKELETAL_ONCOLOGY_CONSULTATION: '1875',
    MUSCULOSKELETAL_ONCOLOGY_FOLLOW_UP: '1876',
    MUSCULOSKELETAL_SURGERY: '1877',
    MUSCULOSKELETAL_TUMOR: '1878',
    MYELOPROLIFERATIVE_DISORDER: '1879',
    MYOCARDIAL_PERFUSION_IMAGING_CARDIAC_STRESS_TEST: '1880',
    NAIL_REMOVAL: '1881',
    NASAL_SINUS_CANCER: '1882',
    BIOFEEDBACK: '1883',
    NATUROPATHIC_DOCTOR_CONSULTATION: '1884',
    NATUROPATHIC_DOCTOR_FOLLOW_UP: '1885',
    NAUSEA_AND_VOMITING: '1886',
    NECK_MASS: '1887',
    NECK_PAIN: '1888',
    NECK_PROBLEMS: '1889',
    NECROTIZING_SOFT_TISSUE_INFECTION: '1890',
    NEONATAL_JAUNDICE: '1891',
    NEONATAL_PERINATAL_EMERGENCY: '1892',
    NEPHRITIS: '1893',
    BLADDER_AND_BOWEL_MANAGEMENT: '1894',
    NEPHROTIC_SYNDROME: '1895',
    NERVE_BLOCK: '1896',
    NEURODEGENERATIVE_DISORDER: '1897',
    NEURODEVELOPMENTAL_CONSULTATION: '1898',
    NEURODEVELOPMENTAL_FOLLOW_UP: '1899',
    NEUROLOGICAL_INJECTION_BOTOX_IFN_TRIGGER_POINT: '1900',
    BLADDER_AND_KIDNEY_ULTRASOUND: '1901',
    NEUROLOGY_PROBLEM: '1902',
    NEUROMUSCULAR_DISORDER_CAUSING_SLEEP_DISTURBANCE: '1903',
    NEUROMUSCULAR_SPECIALIST_CONSULTATION: '1904',
    NEUROMUSCULAR_SPECIALIST_FOLLOW_UP: '1905',
    NEUROPATHIC_PAIN: '1906',
    NEUROSTIMULATION_TENS: '1907',
    NOSE_SURGERY_CONSULTATION: '1908',
    BLADDER_CANCER: '1909',
    NOSE_SURGERY_FOLLOW_UP: '1910',
    NUCLEAR_MEDICINE_CONSULTATION: '1911',
    NUCLEAR_MEDICINE_FOLLOW_UP: '1912',
    NUCLEAR_MEDICINE_STUDY: '1913',
    OB_GYN_EMERGENCY: '1914',
    OBESITY_WEIGHT_LOSS_CONSULTATION: '1915',
    BLADDER_PAIN_INTERSTITIAL_CYSTITIS: '1916',
    OBSTRUCTIVE_SLEEP_APNEA: '1917',
    OCCUPATIONAL_HEALTH_CONSULTATION: '1918',
    OCCUPATIONAL_INJURIES: '1919',
    OCCUPATIONAL_LUNG_DISEASE_ASBESTOS_AND_OTHER: '1920',
    OCCUPATIONAL_MEDICINE_FOLLOW_UP: '1921',
    OCCUPATIONAL_THERAPY_CONSULTATION: '1922',
    OCCUPATIONAL_THERAPY_FOLLOW_UP: '1923',
    OPTIC_NEURITIS_RETINITIS: '1924',
    OPTOMETRY_CONSULTATION: '1925',
    OPTOMETRY_FOLLOW_UP: '1926',
    BLOOD_CLOT: '1927',
    ORAL_FACIAL_BIOPSY: '1928',
    ORAL_CANCER: '1929',
    ORAL_SURGERY_EMERGENCY_VISIT: '1930',
    ORBITAL_PLASTIC_SURGERY: '1931',
    ORCHITIS_EPIDIDYMITIS: '1932',
    ORTHOPEDIC_ONCOLOGY_CONSULTATION: '1933',
    ORTHOPEDIC_TRAUMA: '1934',
    ORTHOTICS: '1935',
    OSTEOARTHRITIS: '1936',
    OSTEOGENESIS_IMPERFECTA: '1937',
    OSTEOMYELITIS: '1938',
    OSTEOPATHIC_CONSULTATION: '1939',
    OSTEOPATHIC_MANIPULATION: '1940',
    OSTEOPOROSIS: '1941',
    OTHER_BIOPSY: '1942',
    BLOOD_SMEAR: '1943',
    OVARIAN_CYSTS: '1944',
    OVARIAN_HYPERSTIMULATION: '1945',
    PACEMAKER_CHECKUP: '1946',
    PAIN_CONTROL: '1947',
    PAIN_IN_EXTREMITIES: '1948',
    PAINFUL_MENSTRUATION_DYSMENORRHEA: '1949',
    PALSY_PERIPHERAL_NEUROPATHY: '1950',
    PANCREAS_TRANSPLANT_CONSULTATION: '1951',
    PANCREAS_TRANSPLANT_FOLLOW_UP: '1952',
    PANCREATIC_CANCER: '1953',
    PARACENTESIS: '1954',
    PARATHYROID_DISORDER: '1955',
    PARTIAL_DENTURES: '1956',
    PEDIATRIC_BEREAVEMENT: '1957',
    PEDIATRIC_PAIN_MEDICINE_INJECTION: '1958',
    PEDIATRIC_ABDOMINAL_PAIN: '1959',
    PEDIATRIC_ABDOMINAL_SURGERY: '1960',
    PEDIATRIC_ABDOMINAL_WALL_SURGERY: '1961',
    PEDIATRIC_ACID_REFLUX_HEARTBURN: '1962',
    PEDIATRIC_ACNE: '1963',
    PEDIATRIC_ADD_ADHD_HYPERACTIVE: '1964',
    PEDIATRIC_ADDICTION: '1965',
    PEDIATRIC_ADENOIDECTOMY_CONSULTATION: '1966',
    PEDIATRIC_ADENOIDECTOMY_FOLLOW_UP: '1967',
    PEDIATRIC_ADRENAL_CANCER: '1968',
    PEDIATRIC_ALLERGIC_ARTHRITIS: '1969',
    PEDIATRIC_ALLERGIC_ASTHMA: '1970',
    PEDIATRIC_ALLERGIC_COUGH: '1971',
    PEDIATRIC_ALLERGIC_EYE_PROBLEMS: '1972',
    PEDIATRIC_ALLERGY: '1973',
    PEDIATRIC_ALLERGY_SHOTS: '1974',
    PEDIATRIC_ALLERGY_TESTING: '1975',
    PEDIATRIC_AMPUTEE_CARE: '1976',
    PEDIATRIC_ANEMIA: '1977',
    PEDIATRIC_ANGER_MANAGEMENT: '1978',
    BONE_MARROW_BIOPSY: '1979',
    PEDIATRIC_ANIMAL_ALLERGIES: '1980',
    PEDIATRIC_ANKLE_PROBLEMS: '1981',
    PEDIATRIC_ANXIETY: '1982',
    PEDIATRIC_APPENDICITIS_APPENDECTOMY: '1983',
    PEDIATRIC_ASTHMA: '1984',
    PEDIATRIC_BACK_PROBLEMS: '1985',
    PEDIATRIC_BEHAVIORAL_THERAPY: '1986',
    PEDIATRIC_BENIGN_NEOPLASM: '1987',
    PEDIATRIC_BIOPSY: '1988',
    PEDIATRIC_BIPOLAR_DISORDER: '1989',
    BONE_SCAN: '1990',
    PEDIATRIC_BIRTH_CONTROL_CONTRACEPTION: '1991',
    PEDIATRIC_BIRTH_INJURY: '1992',
    PEDIATRIC_BLADDER_AND_BOWEL_MANAGEMENT: '1993',
    PEDIATRIC_BLEEDING_DISORDERS: '1994',
    PEDIATRIC_BLOOD_IN_URINE_HEMATURIA: '1995',
    PEDIATRIC_BLOOD_SMEAR: '1996',
    PEDIATRIC_BLOOD_TRANSFUSION_CONSULTATION: '1997',
    PEDIATRIC_BLOOD_TRANSFUSION_FOLLOW_UP: '1998',
    PEDIATRIC_BONE_MARROW_BIOPSY: '1999',
    PEDIATRIC_BONE_MARROW_TRANSPLANT_CONSULTATION: '2000',
    BOWEL_AND_BLADDER_MANAGEMENT: '2001',
    PEDIATRIC_BONE_MARROW_TRANSPLANT_FOLLOW_UP: '2002',
    PEDIATRIC_BRACE: '2003',
    PEDIATRIC_BRAIN_OR_SPINAL_CORD_CANCER: '2004',
    PEDIATRIC_BRAIN_AND_SPINAL_CORD_TUMOR: '2005',
    PEDIATRIC_BRAIN_ANEURYSM_TREATMENT: '2006',
    PEDIATRIC_BRAIN_HEMORRHAGE: '2007',
    PEDIATRIC_BRAIN_INFECTION: '2008',
    PEDIATRIC_BRAIN_METASTASIS: '2009',
    PEDIATRIC_BRAIN_SURGERY: '2010',
    ORTHOPEDIC_BRACE: '2011',
    PEDIATRIC_BRAIN_TRAUMA_INJURY: '2012',
    PEDIATRIC_BROKEN_TOOTH: '2013',
    PEDIATRIC_BRONCHOSCOPY: '2014',
    PEDIATRIC_CANCER_SECOND_OPINION: '2015',
    PEDIATRIC_CANCER_TREATMENT: '2016',
    PEDIATRIC_CARDIOLOGY_EMERGENCY: '2017',
    PEDIATRIC_CARDIOTHORACIC_SURGERY_CONSULTATION: '2018',
    PEDIATRIC_CARDIOTHORACIC_SURGERY_FOLLOW_UP: '2019',
    PEDIATRIC_CENTRAL_LINE_PLACEMENT: '2020',
    PEDIATRIC_CERUMEN_REMOVAL: '2021',
    PEDIATRIC_CHEMOTHERAPY: '2022',
    PEDIATRIC_CHEST_WALL_SURGERY: '2023',
    PEDIATRIC_CLEFT_LIP_AND_OR_PALATE: '2024',
    PEDIATRIC_CLOTTING_DISORDERS: '2025',
    PEDIATRIC_COLONOSCOPY: '2026',
    PEDIATRIC_CONNECTIVE_TISSUE_DISORDER_INTERSTITIAL_LUNG_DISEASE: '2027',
    PEDIATRIC_CRITICAL_CARE_CONSULTATION: '2028',
    PEDIATRIC_CRITICAL_CARE_FOLLOW_UP: '2029',
    PEDIATRIC_CROHNS_DISEASE: '2030',
    PEDIATRIC_CRUTCHES_WHEELCHAIR: '2031',
    BRACES_INVISALIGN_REMOVAL: '2032',
    PEDIATRIC_DENTIST_PREVENTIVE_VISIT: '2033',
    PEDIATRIC_DEPRESSION: '2034',
    PEDIATRIC_DERMATOLOGY_SURGERY: '2035',
    PEDIATRIC_DERMATOLOGY_CONSULTATION: '2036',
    PEDIATRIC_DERMATOLOGY_FOLLOW_UP: '2037',
    PEDIATRIC_DEVELOPMENT_DISORDER: '2038',
    PEDIATRIC_DIABETES_CONSULTATION: '2039',
    BRACES_INVISALIGN_REPAIR_OR_REPLACEMENT: '2040',
    PEDIATRIC_DIABETES_FOLLOW_UP: '2041',
    PEDIATRIC_DIALYSIS: '2042',
    PEDIATRIC_DIALYSIS_CATHETER_PLACEMENT: '2043',
    PEDIATRIC_DIARRHEA: '2044',
    PEDIATRIC_DRUG_ALLERGY: '2045',
    PEDIATRIC_EAR_INFECTION: '2046',
    PEDIATRIC_EAR_PAIN: '2047',
    PEDIATRIC_EAR_NOSE_OR_THROAT_PROBLEM: '2048',
    PEDIATRIC_EATING_DISORDER: '2049',
    BRAIN_AND_NERVOUS_SYSTEM_CANCER: '2050',
    PEDIATRIC_ECG_EKG: '2051',
    PEDIATRIC_ECHOCARDIOGRAM: '2052',
    PEDIATRIC_ECZEMA: '2053',
    PEDIATRIC_EEG: '2054',
    PEDIATRIC_ELBOW_PROBLEMS: '2055',
    PEDIATRIC_EMG_NCS: '2056',
    PEDIATRIC_ENDOCARDITIS: '2057',
    PEDIATRIC_ENDOSCOPY: '2058',
    PEDIATRIC_ENT_EMERGENCY: '2059',
    BRAIN_HEMORRHAGE: '2060',
    PEDIATRIC_EPILEPSY_SEIZURE_DISORDER: '2061',
    PEDIATRIC_EVALUATION_OF_A_FACIAL_MASS: '2062',
    PEDIATRIC_EYE_CANCER: '2063',
    PEDIATRIC_EYE_PROBLEM: '2064',
    PEDIATRIC_FAILURE_TO_THRIVE: '2065',
    PEDIATRIC_FAINTING_SYNCOPE: '2066',
    PEDIATRIC_FEVER: '2067',
    PEDIATRIC_FLU: '2068',
    PEDIATRIC_FOOD_INTOLERANCE_ALLERGY: '2069',
    BRAIN_INFECTION: '2070',
    PEDIATRIC_FOOT_DEFORMATION: '2071',
    PEDIATRIC_FOOT_OR_ANKLE_PROBLEM: '2072',
    PEDIATRIC_FREEZING_OF_WARTS: '2073',
    PEDIATRIC_FUNGAL_INFECTION: '2074',
    PEDIATRIC_GASTROENTEROLOGY_CONSULTATION: '2075',
    PEDIATRIC_GASTROENTEROLOGY_EMERGENCY: '2076',
    PEDIATRIC_GASTROENTEROLOGY_FOLLOW_UP: '2077',
    BRAIN_METASTASIS: '2078',
    PEDIATRIC_HAND_PROBLEM: '2079',
    PEDIATRIC_HAY_FEVER_SEASONAL_ALLERGIES: '2080',
    PEDIATRIC_HEAD_AND_NECK_SURGERY: '2081',
    PEDIATRIC_HEAD_INJURY: '2082',
    PEDIATRIC_HEADACHE: '2083',
    PEDIATRIC_HEARING_PROBLEMS: '2084',
    BRAIN_SPINAL_CORD_BIOPSY: '2085',
    PEDIATRIC_HEART_MURMUR_VALVE_OR_VESSEL_DEFECT: '2086',
    PEDIATRIC_HEART_RHYTHM_PROBLEM_PALPITATIONS_ARRHYTHMIA: '2087',
    PEDIATRIC_HEART_TRANSPLANT_CONSULTATION: '2088',
    PEDIATRIC_HEART_TRANSPLANT_FOLLOW_UP: '2089',
    PEDIATRIC_HEPATITIS_JAUNDICE: '2090',
    PEDIATRIC_HERNIA: '2091',
    PEDIATRIC_HIGH_BLOOD_PRESSURE_HYPERTENSION: '2092',
    PEDIATRIC_HIGH_CHOLESTEROL_LIPID_PROBLEM: '2093',
    BRAIN_SPINAL_CORD_CANCER: '2094',
    PEDIATRIC_HIP_PROBLEMS: '2095',
    PEDIATRIC_HIV_AIDS: '2096',
    PEDIATRIC_HIV_AIDS_CONSULTATION: '2097',
    PEDIATRIC_HIV_AIDS_FOLLOW_UP: '2098',
    PEDIATRIC_HIVES: '2099',
    PEDIATRIC_HIV_RELATED_CANCER: '2100',
    PEDIATRIC_HORMONE_PROBLEM: '2101',
    PEDIATRIC_HYDROCEPHALUS_BRAIN_MALFORMATION: '2102',
    PEDIATRIC_ILLNESS: '2103',
    PEDIATRIC_IMMUNODEFICIENCY: '2104',
    BRAIN_SPINAL_CORD_TUMOR: '2105',
    PEDIATRIC_INFECTION_CONSULTATION: '2106',
    PEDIATRIC_INFECTION_FOLLOW_UP: '2107',
    PEDIATRIC_INSECT_BITES: '2108',
    PEDIATRIC_ITCHING: '2109',
    PEDIATRIC_JOINT_ASPIRATION: '2110',
    PEDIATRIC_JOINT_INJECTION: '2111',
    PEDIATRIC_JOINT_PROBLEM: '2112',
    PEDIATRIC_KIDNEY_BLADDER_CANCER: '2113',
    PEDIATRIC_KIDNEY_BIOPSY: '2114',
    BRAIN_PERFUSION_SCAN: '2115',
    PEDIATRIC_KIDNEY_STONES: '2116',
    PEDIATRIC_KIDNEY_TRANSPLANT_CONSULTATION: '2117',
    PEDIATRIC_KIDNEY_TRANSPLANT_FOLLOW_UP: '2118',
    PEDIATRIC_KIDNEY_ULTRASOUND: '2119',
    PEDIATRIC_KNEE_PROBLEMS: '2120',
    PEDIATRIC_LAPAROSCOPIC_SURGERY_CONSULTATION: '2121',
    PEDIATRIC_LAPAROSCOPIC_SURGERY_FOLLOW_UP: '2122',
    PEDIATRIC_LEARNING_PROBLEMS: '2123',
    BRAIN_TRAUMA_INJURY: '2124',
    PEDIATRIC_LEG_PROBLEM: '2125',
    PEDIATRIC_LEUKEMIA: '2126',
    PEDIATRIC_LEUKOCYTOSIS_HIGH_WHITE_BLOOD_COUNT: '2127',
    PEDIATRIC_LEUKOPENIA_LOW_WHITE_BLOOD_COUNT: '2128',
    PEDIATRIC_LIGAMENT_SPRAIN: '2129',
    PEDIATRIC_LIVER_BIOPSY: '2130',
    PEDIATRIC_LIVER_TRANSPLANT_CONSULTATION: '2131',
    PEDIATRIC_LIVER_TRANSPLANT_FOLLOW_UP: '2132',
    PEDIATRIC_LUMBAR_PUNCTURE: '2133',
    BREAST_CANCER: '2134',
    PEDIATRIC_LYME_DISEASE: '2135',
    PEDIATRIC_LYMPHOMA: '2136',
    PEDIATRIC_MENINGITIS: '2137',
    PEDIATRIC_MENSTRUAL_PROBLEMS: '2138',
    PEDIATRIC_METASTATIC_CANCER_OF_UNKNOWN_PRIMARY: '2139',
    PEDIATRIC_MOBILITY_THERAPY: '2140',
    PEDIATRIC_MOVEMENT_DISORDER: '2141',
    PEDIATRIC_MOVEMENT_DISORDER_EXERCISES: '2142',
    BREAST_CANCER_GENETIC_COUNSELING: '2143',
    PEDIATRIC_MULTIPLE_SCLEROSIS: '2144',
    PEDIATRIC_MUSCLE_DISORDERS: '2145',
    PEDIATRIC_MUSCLE_STRAIN: '2146',
    PEDIATRIC_MUSCULOSKELETAL_SURGERY: '2147',
    PEDIATRIC_MUSCULOSKELETAL_TUMOR: '2148',
    PEDIATRIC_MYELOPROLIFERATIVE_DISORDER: '2149',
    PEDIATRIC_NAIL_REMOVAL: '2150',
    PEDIATRIC_NAUSEA_AND_VOMITING: '2151',
    PEDIATRIC_NECK_MASS: '2152',
    BREAST_CANCER_HIGH_RISK_SCREENING: '2153',
    PEDIATRIC_NECK_PROBLEMS: '2154',
    PEDIATRIC_NEPHRITIS: '2155',
    PEDIATRIC_NEPHROLOGY_CONSULTATION: '2156',
    PEDIATRIC_NEPHROLOGY_FOLLOW_UP: '2157',
    PEDIATRIC_NEPHROTIC_SYNDROME: '2158',
    PEDIATRIC_NEUROLOGY_CONSULTATION: '2159',
    PEDIATRIC_NEUROLOGY_FOLLOW_UP: '2160',
    PEDIATRIC_NEUROSURGERY_CONSULTATION: '2161',
    BREAST_CANCER_SCREENING: '2162',
    PEDIATRIC_NEUROSURGERY_FOLLOW_UP: '2163',
    PEDIATRIC_OBESITY_WEIGHT_LOSS_CONSULTATION: '2164',
    PEDIATRIC_OBSESSIVE_COMPULSIVE_DISORDER: '2165',
    PEDIATRIC_ONCOLOGY_SURGERY: '2166',
    PEDIATRIC_ORAL_CANCER: '2167',
    PEDIATRIC_ORCHITIS_EPIDIDYMITIS: '2168',
    PEDIATRIC_ORTHOPEDIC_TRAUMA: '2169',
    PEDIATRIC_OTITIS_MEDIA: '2170',
    PEDIATRIC_PAIN_MANAGEMENT: '2171',
    PEDIATRIC_PAIN_MEDICATION_PRESCRIPTION: '2172',
    PEDIATRIC_PAIN_MEDICINE_CONSULTATION: '2173',
    PEDIATRIC_PAIN_MEDICINE_FOLLOW_UP: '2174',
    PEDIATRIC_PAP_SMEAR_ANNUAL_GYN_EXAM: '2175',
    PEDIATRIC_PARACENTESIS: '2176',
    PEDIATRIC_PELVIC_SURGERY: '2177',
    PEDIATRIC_PERSONALITY_DISORDER: '2178',
    PEDIATRIC_PHARYNGITIS_STREP_THROAT: '2179',
    PEDIATRIC_PHYSIATRIST_CONSULTATION: '2180',
    PEDIATRIC_PHYSIATRIST_FOLLOW_UP: '2181',
    PEDIATRIC_PLASTIC_SURGERY_CONSULTATION: '2182',
    PEDIATRIC_PLASTIC_SURGERY_FOLLOW_UP: '2183',
    PEDIATRIC_PNEUMONIA_AND_BRONCHITIS: '2184',
    PEDIATRIC_PNEUMOTHORAX: '2185',
    PEDIATRIC_POISON_IVY_OR_POISON_OAK: '2186',
    PEDIATRIC_POLYCYTHEMIA_VERA: '2187',
    BREAST_SURGERY_SECOND_OPINION: '2188',
    PEDIATRIC_POST_SURGERY_ANESTHESIA_FOLLOW_UP: '2189',
    PEDIATRIC_POST_SURGERY_FOLLOW_UP: '2190',
    PEDIATRIC_PRE_SPORTS_EVALUATION: '2191',
    PEDIATRIC_PRE_SURGERY_ANESTHESIA_CONSULTATION: '2192',
    PEDIATRIC_PROSTHESIS: '2193',
    PEDIATRIC_PROTEIN_IN_URINE_PROTEINURIA: '2194',
    PEDIATRIC_PSYCHIATRIC_MEDICATION_REVIEW: '2195',
    PEDIATRIC_PSYCHIATRIC_REHABILITATION: '2196',
    PEDIATRIC_PSYCHOTHERAPY: '2197',
    ADDICTION_SPECIALIST_CONSULTATION: '2198',
    BREAST_ULTRASOUND: '2199',
    PEDIATRIC_PTSD_SEXUAL_ABUSE_COUNSELING: '2200',
    PEDIATRIC_PULMONARY_FUNCTION_TESTING: '2201',
    PEDIATRIC_RADIOTHERAPY_CONSULTATION: '2202',
    PEDIATRIC_RADIOTHERAPY_FOLLOW_UP: '2203',
    PEDIATRIC_RASH: '2204',
    PEDIATRIC_RENAL_FAILURE: '2205',
    PEDIATRIC_RHEUMATOLOGIST_CONSULTATION: '2206',
    PEDIATRIC_RHEUMATOLOGIST_FOLLOW_UP: '2207',
    PEDIATRIC_SARCOMA_BONE_AND_SOFT_TISSUE_CANCER: '2208',
    PEDIATRIC_SCABIES: '2209',
    PEDIATRIC_SCAR_REVISION: '2210',
    PEDIATRIC_SCOLIOSIS_SPINE_DEFORMATION: '2211',
    PEDIATRIC_SECOND_OPINION: '2212',
    PEDIATRIC_SEIZURES_EPILEPSY: '2213',
    PEDIATRIC_SEVERE_INFECTION: '2214',
    PEDIATRIC_SEX_HORMONE_DISORDER: '2215',
    PEDIATRIC_GENDER_DYSPHORIA: '2216',
    PEDIATRIC_SEXUALLY_TRANSMITTED_INFECTION: '2217',
    PEDIATRIC_SHOULDER_PROBLEM: '2218',
    BRUXISM_TEETH_GRINDING: '2219',
    PEDIATRIC_SICKLE_CELL_DISEASE: '2220',
    PEDIATRIC_SINUS_PROBLEMS: '2221',
    PEDIATRIC_SKIN_AND_SOFT_TISSUE_INFECTION_INCLUDING_MRSA: '2222',
    PEDIATRIC_SKIN_BIOPSY_REMOVAL_OF_SKIN_LESION: '2223',
    PEDIATRIC_SKULL_BASE_SURGERY: '2224',
    PEDIATRIC_SLEEP_PROBLEMS_SNORING: '2225',
    PEDIATRIC_SOMATOFORM_DISORDER_FACTITIOUS: '2226',
    BURN_AND_WOUND_CORRECTION: '2227',
    PEDIATRIC_SPINAL_CORD_DISORDER: '2228',
    PEDIATRIC_SPINAL_CORD_SURGERY: '2229',
    PEDIATRIC_SPINAL_CORD_TRAUMA_INJURY: '2230',
    PEDIATRIC_SPIROMETRY: '2231',
    PEDIATRIC_SPLEEN_PROBLEMS: '2232',
    PEDIATRIC_SPONDYLOLYSIS: '2233',
    PEDIATRIC_SPORT_INJURY: '2234',
    PEDIATRIC_SPORTS_MEDICINE_CONSULTATION: '2235',
    PEDIATRIC_SPORTS_MEDICINE_FOLLOW_UP: '2236',
    PEDIATRIC_SPORTS_PHYSICAL: '2237',
    PEDIATRIC_SURGERY_SECOND_OPINION: '2238',
    PEDIATRIC_TESTICULAR_CANCER: '2239',
    PEDIATRIC_THALASSEMIA: '2240',
    PEDIATRIC_THERAPEUTIC_EXERCISE: '2241',
    PEDIATRIC_THORACENTESIS: '2242',
    PEDIATRIC_THORACIC_SURGERY: '2243',
    PEDIATRIC_THORACOSCOPY: '2244',
    PEDIATRIC_THROMBOCYTOPENIA_LOW_PLATELETS: '2245',
    PEDIATRIC_THROMBOCYTOSIS_HIGH_PLATELETS: '2246',
    CANCER: '2247',
    PEDIATRIC_THYROID_DISORDER: '2248',
    PEDIATRIC_TICS_TOURETTE_SYNDROME: '2249',
    PEDIATRIC_TMJ_TEMPORO_MANDIBULAR_JOINT_PAIN: '2250',
    PEDIATRIC_TONSILLECTOMY_CONSULTATION: '2251',
    PEDIATRIC_TONSILLECTOMY_FOLLOW_UP: '2252',
    PEDIATRIC_TOOTH_EXTRACTION: '2253',
    PEDIATRIC_TORTICOLLIS_NECK_DEFORMATION: '2254',
    PEDIATRIC_TRACHEOSTOMY: '2255',
    PEDIATRIC_TRAUMA_SURGERY_CONSULTATION: '2256',
    PEDIATRIC_TRAVEL_MEDICINE_CONSULTATION: '2257',
    PEDIATRIC_TROPICAL_DISEASE_PARASITE_MALARIA: '2258',
    PEDIATRIC_TUBERCULOSIS: '2259',
    PEDIATRIC_NON_BACTERIAL_LUNG_INFECTION: '2260',
    PEDIATRIC_ULCERATIVE_COLITIS: '2261',
    PEDIATRIC_URINARY_TRACT_INFECTION: '2262',
    PEDIATRIC_VACCINES: '2263',
    PEDIATRIC_VASCULAR_MALFORMATION: '2264',
    PEDIATRIC_VASCULAR_SURGERY: '2265',
    CANTHOPLASTY: '2266',
    PEDIATRIC_VIRAL_EXANTHEM: '2267',
    PEDIATRIC_VISUAL_PROBLEMS: '2268',
    PEDIATRIC_WARTS: '2269',
    PEDIATRIC_WEAKNESS_PALSY_PERIPHERAL_NEUROPATHY: '2270',
    PEDIATRIC_WHEELCHAIR_CRUTCHES: '2271',
    PEDIATRIC_WOUND_CARE: '2272',
    PEDIATRIC_WRIST_PROBLEM: '2273',
    PELVIC_INFLAMMATORY_DISEASE_ENDOMETRITIS: '2274',
    PELVIC_PAIN: '2275',
    PELVIC_SURGERY: '2276',
    CARBON_MONOXIDE_POISONING: '2277',
    PELVIC_ULTRASOUND: '2278',
    PENILE_CANCER: '2279',
    PERICARDIAL_EFFUSION: '2280',
    PERICARDITIS: '2281',
    PERIODONTIST_EMERGENCY: '2282',
    PERIPHERAL_VASCULAR_DISEASE: '2283',
    PERSONALITY_DISORDER: '2284',
    CARDIAC_BIOPSY: '2285',
    PET_SPECT_SCAN: '2286',
    PHYSICAL_THERAPY: '2287',
    PITUITARY_TUMOR_PROLACTINOMA: '2288',
    POLYCYSTIC_KIDNEY_DISEASE: '2290',
    POLYCYTHEMIA_VERA: '2291',
    ADDICTION_SPECIALIST_FOLLOW_UP: '2292',
    CARDIAC_MRI: '2293',
    POLYPHARMACY: '2294',
    POLYSOMNOGRAPHY: '2295',
    PORTAL_HYPERTENSION: '2296',
    POST_MENOPAUSAL_BLEEDING: '2297',
    POST_PARTUM_VISIT: '2298',
    POST_SURGERY_ANESTHESIA_FOLLOW_UP: '2299',
    PRE_POST_OP_VISIT: '2300',
    PREGNANCY_MASSAGE: '2301',
    PREMENSTRUAL_MOOD_DISORDER_PMS_PMDD: '2302',
    CARDIAC_PET_SCAN: '2303',
    PRE_SPORTS_EVALUATION: '2304',
    PRE_SPORTS_PHYSICAL: '2305',
    PRE_SURGERY_ANESTHESIA_CONSULTATION: '2306',
    PRIMARY_CARE_CONSULTATION: '2307',
    PROCEDURAL_DERMATOLOGY_CONSULTATION: '2308',
    PROCEDURAL_DERMATOLOGY_CONSULTATION_FOLLOW_UP: '2309',
    PROCTOLOGY_CONSULTATION: '2310',
    PROCTOLOGY_FOLLOW_UP: '2311',
    CARDIAC_TUMOR: '2312',
    PSYCHIATRIC_MEDICATION_REVIEW: '2313',
    PSYCHIATRIC_REHABILITATION: '2314',
    PSYCHOLOGY_CONSULTATION: '2315',
    PSYCHOSOMATIC_MEDICINE_FOLLOW_UP: '2316',
    PSYCHOSOMATIC_MEDICINE_SPECIALIST_CONSULTATION: '2317',
    PSYCHOTHERAPY_INTAKE_INITIAL_VISIT: '2318',
    CARDIOLOGY_EMERGENCY: '2319',
    PTOSIS: '2320',
    PTOSIS_REPAIR: '2321',
    POST_TRAUMATIC_STRESS_DISORDER_PTSD_COUNSELING: '2322',
    PULMONARY_EMBOLISM: '2323',
    PULMONARY_EMBOLISM_SCAN: '2324',
    PULMONARY_EMERGENCY: '2325',
    PULMONARY_HYPERTENSION: '2326',
    PULMONARY_PERFUSION_AND_VENTILATION_SCAN_VQ_SCAN: '2327',
    RADIATION_THERAPY: '2328',
    RADIOFREQUENCY_ABLATION: '2329',
    CARDIOMYOPATHY: '2330',
    RADIOFREQUENCY_BLOCK: '2331',
    RADIOIMMUNOTHERAPY: '2332',
    RECONSTRUCTIVE_SURGERY: '2333',
    RECTAL_BLEEDING: '2334',
    RECTAL_PROLAPSE: '2335',
    REMOVAL_OF_CYST: '2336',
    CARDIOVASCULAR_DISTRESS: '2337',
    RESPIRATORY_DISTRESS: '2338',
    RETINAL_DETACHMENT: '2339',
    RETINAL_VEIN_ARTERY_OCCLUSION: '2340',
    RETINOPATHY: '2341',
    REVISIONAL_SURGERY: '2342',
    RHEUMATOLOGY_CONSULTATION: '2343',
    RHEUMATOLOGY_FOLLOW_UP: '2344',
    CARDIOVERSION: '2345',
    RISK_MANAGEMENT: '2346',
    SARCOID: '2347',
    SARCOMA_BONE_AND_SOFT_TISSUE_CANCER: '2348',
    KELOIDS: '2349',
    SCIATICA_BACK_PAIN: '2350',
    SCREENING_FOR_DISEASE_PREVENTIVE_MEDICINE: '2351',
    CENTRAL_LINE_PLACEMENT: '2352',
    SEALANT: '2353',
    GENDER_CONFIRMATION_SURGERY: '2354',
    SEX_HORMONE_DISORDER: '2355',
    GENDER_DYSPHORIA: '2356',
    SIDE_EFFECTS_OF_CHEMOTHERAPY: '2357',
    SIDE_EFFECTS_OF_RADIATION_THERAPY: '2358',
    SINUS_SURGEON_CONSULTATION: '2359',
    SINUS_SURGEON_FOLLOW_UP: '2360',
    SKIN_AND_SOFT_TISSUE_INFECTION_INCLUDING_MRSA: '2361',
    CENTRAL_SLEEP_APNEA: '2362',
    SKIN_BIOPSY_REMOVAL_OF_SKIN_LESION: '2363',
    SKIN_CANCER: '2364',
    SKIN_CANCER_SURGERY_CORRECTION: '2365',
    SKIN_PROBLEM: '2366',
    SLEEP_DISORDER: '2367',
    SLEEP_MEDICINE_CONSULTATION: '2368',
    SLEEP_MEDICINE_FOLLOW_UP: '2369',
    SOMATOFORM_DISORDER_FACTITIOUS: '2370',
    CEREBRAL_PALSY_OTHER_MOTOR_DISABILITIES: '2371',
    SPEECH_AID: '2372',
    SPEECH_AND_SWALLOWING_STUDY: '2373',
    SPINA_BIFIDA: '2374',
    SPINAL_CORD_DISORDER: '2375',
    SPINAL_CORD_MINIMALLY_INVASIVE_SURGERY: '2376',
    SPINAL_CORD_RECONSTRUCTIVE_SURGERY: '2377',
    SPINAL_CORD_SECOND_OPINION: '2378',
    SPINAL_CORD_TRAUMA_INJURY: '2379',
    NEURO_ONCOLOGY_FOLLOW_UP: '2380',
    RETAINER_CHECKUP: '2381',
    NEUROPSYCHIATRY_CONSULTATION: '2382',
    NEUROPSYCHIATRY_FOLLOW_UP: '2383',
    LASER_VEIN_TREATMENT: '2384',
    ALLERGY_NUTRITION: '2385',
    DIABETIC_NUTRITION: '2386',
    SPORTS_NUTRITION_EVALUATION: '2387',
    HIGH_BLOOD_PRESSURE_DIET_CONSULTATION: '2388',
    KIDNEY_HEALTH_DIET_CONSULTATION: '2389',
    INFERTILITY_NUTRITION_CONSULTATION: '2390',
    PREGNANCY_NUTRITION_CHECKUP: '2391',
    BREAST_FEEDING_NUTRITION_CHECKUP: '2392',
    EATING_DISORDER_NUTRITION_CONSULTATION: '2393',
    UNDERWEIGHT_NUTRITION_CONSULTATION: '2394',
    REFLUX_HEARTBURN_DIET_CONSULTATION: '2395',
    IBD_DIET_CONSULTATION: '2396',
    LIVER_HEALTH_DIET_CONSULTATION: '2397',
    CHILD_NUTRITION_HEALTH_CHECKUP: '2398',
    GASTRIC_BYPASS_NUTRITION: '2399',
    HEARING_TEST: '2401',
    DAMAGE_TO_THE_EAR_AND_DISEASE_OF_THE_EAR: '2402',
    PEDIATRIC_AUDIOLOGY: '2403',
    TUMOR_AFFECTING_HEARING_ACOUSTIC_NEUROMA: '2404',
    STROKE: '2405',
    PROBLEM_WITH_HEARING_AID: '2406',
    PROBLEM_WITH_BALANCE: '2407',
    EVALUATION_FOR_COCHLEAR_IMPLANT: '2408',
    VARICOSE_VEIN_TREATMENT: '2409',
    OBESITY_NUTRITION_CONSULTATION: '2410',
    DEVELOPMENTAL_VISION_EXAM: '2411',
    WELLNESS_CARE: '2412',
    SHOULDER_PAIN: '2413',
    SCOLIOSIS: '2415',
    STRESS: '2416',
    OVULATION_INDUCTION: '2417',
    DONOR_SPERM: '2418',
    DONOR_EGG: '2419',
    GESTATIONAL_CARRIER_SURROGATE: '2420',
    SAME_SEX_COUPLE_INFERTILITY: '2421',
    PRE_IMPLANTATION_GENETIC_DIAGNOSIS: '2422',
    COMPARATIVE_GENOMIC_HYBRIDIZATION: '2423',
    SINGLE_EMBRYO_TRANSFER: '2424',
    EGG_FREEZING_FERTILITY_PRESERVATION: '2425',
    MALE_FACTOR_INFERTILITY: '2426',
    SIX_MONTH_WELL_BABY_CHECKUP: '2427',
    CUPPING: '2428',
    ORTHOKERATOLOGY_CORNEAL_REFRACTIVE_THERAPY: '2429',
    HEART_HEALTH_CONSULTATION: '2430',
    SPLIT_EARLOBE_REPAIR: '2431',
    FRACTIONAL_LASER_TREATMENT: '2432',
    TATTOO_REMOVAL: '2433',
    PHOTODYNAMIC_THERAPY: '2434',
    IPL_INTENSE_PULSED_LIGHT_TREATMENT: '2435',
    VASECTOMY_REVERSAL: '2436',
    MINIMALLY_INVASIVE_VASECTOMY_REVERSAL: '2437',
    MOUTHGUARD: '2438',
    URETEROSCOPY: '2439',
    PROSTATE_LASER_PROCEDURES: '2440',
    CRYOABLATION: '2441',
    LOW_TESTOSTERONE: '2443',
    LOW_LIBIDO: '2444',
    ELEVATED_PSA: '2445',
    ANORGASMIA: '2446',
    HEMATURIA: '2447',
    HEMATOSPERMIA: '2448',
    VARICOCELE: '2449',
    SPIDER_VEIN_TREATMENT: '2450',
    LUMINEERS: '2451',
    INJURY_MINOR_LACERATION: '2452',
    EAR_IMPRESSIONS_FOR_IN_EAR_MONITOR: '2453',
    ASSISTIVE_LEARNING_DEVICES_AND_CUSTOMIZED_TELEPHONES: '2454',
    VISION_THERAPY: '2455',
    OPTIC_NEURITIS: '2456',
    FACIAL: '2457',
    PLANTAR_FASCIITIS: '2458',
    OVARIAN_CANCER_SCREENING: '2460',
    DYSLEXIA: '2461',
    GAMETRICS: '2462',
    SHINGLES: '2463',
    ESSURE_INCISION_FREE_STERILIZATION: '2464',
    LAPAROSCOPIC_TUBAL_LIGATION: '2465',
    IUD_REMOVAL: '2466',
    NEXPLANON_REMOVAL: '2467',
    NEXPLANON_INSERTION: '2468',
    LEEP_PROCEDURE_FOR_ABNORMAL_PAP_SMEAR: '2469',
    ENDOMETRIAL_ABLATION: '2470',
    HYSTEROSCOPY: '2471',
    LASER_DENTAL_TREATMENT: '2472',
    NEW_PATIENT_EXAM_ADULT: '2473',
    SLEEP_APNEA_SNORING_DEVICE: '2474',
    DETOXIFICATION: '2475',
    CARDIOTHORACIC_SURGERY_CONSULTATION: '2476',
    BLOOD_WORK: '2477',
    ANNUAL_EXAM: '2478',
    PSYCHOLOGICAL_TESTING: '2479',
    UROLOGICAL_SURGERY_CONSULTATION: '2480',
    APPLIED_KINESIOLOGY: '2481',
    BIOFEEDBACK_TREATMENT: '2482',
    COURT_EVALUATIONS: '2483',
    FUNCTIONAL_CAPACITY_EVALUATION_PHYSICAL: '2484',
    FUNCTIONAL_CAPACITY_EVALUATION_MENTAL: '2485',
    IMMIGRATION_MEDICAL_EXAMINATION: '2486',
    POST_EXPOSURE_PROPHYLAXIS_PEP: '2487',
    URINARY_FREQUENCY: '2488',
    ENTROCELE: '2489',
    RECTOCELE: '2490',
    CROWN_LENGTHENING: '2491',
    SCALING_AND_ROOT_PLANING: '2492',
    KERATOCONUS: '2493',
    BLEPHAROSPASM: '2494',
    COLOR_VISION_DEFICIENCY: '2495',
    SJOGRENS_SYNDROME: '2496',
    NECK_PROBLEM_REHABILITATION: '2497',
    ORTHOPEDIC_REHABILITATION: '2498',
    CARDIOPULMONARY_PHYSICAL_THERAPY: '2499',
    BAD_BREATH_HALITOSIS: '2500',
    POSTPARTUM_DEPRESSION: '2501',
    LIFE_COACHING: '2502',
    BEHAVIORAL_THERAPY_FOR_SLEEP_PROBLEM: '2503',
    VISUAL_TESTING_FOR_LEARNING_DISABILITY: '2504',
    CONTINUOUS_POSITIVE_AIRWAY_PRESSURE_MANAGEMENT: '2505',
    HEMORRHOID_LIGATION_BANDING: '2506',
    COLORECTAL_CANCER_SCREENING: '2507',
    HORMONE_REPLACEMENT_THERAPY_CONSULTATION: '2508',
    STEM_CELL_THERAPY: '2509',
    B12_SHOT: '2510',
    COLON_HYDROTHERAPY: '2511',
    NUTRITION_RESPONSE_TESTING: '2512',
    SCHOOL_PHOBIA: '2513',
    BULLYING: '2514',
    PERINATAL_LOSS: '2515',
    SEPARATION_ANXIETY: '2516',
    PRE_COLLEGE_FEARS: '2517',
    MALAISE: '2518',
    LONELINESS: '2519',
    CHRONIC_ILLNESS: '2520',
    CIRCUMCISION_PHIMOSIS: '2521',
    SUTURE_REMOVAL: '2522',
    LYMPHEDEMA_THERAPY: '2523',
    GRASTON_TECHNIQUE: '2524',
    RADIAL_SHOCKWAVE_THERAPY: '2525',
    ACTIVE_RELEASE_TECHNIQUE: '2526',
    BIOENERGETIC_TESTING_ASYRA: '2527',
    ULTHERAPY: '2528',
    MOLE_SCREENING_TREATMENT: '2529',
    JOINT_INJECTIONS: '2530',
    VISCOSUPPLEMENT_INJECTIONS: '2531',
    LINGUAL_BRACES_CONSULTATION: '2532',
    MEDICAL_DETOXIFICATION: '2533',
    LASER_RESURFACING: '2534',
    DERMABRASION: '2535',
    SPINAL_DECOMPRESSION: '2536',
    ART_THERAPY: '2537',
    MESOTHELIOMA: '2538',
    NEW_PATIENT_EXAM_CHILD: '2539',
    GYNECOMASTIA: '2540',
    DISCOGRAM: '2541',
    ELECTROMYOGRAPH_EMG: '2542',
    ORAL_APPLIANCE_THERAPY: '2543',
    FOREARM_INJURY_FRACTURE: '2544',
    ANAL_ABSCESS_FISTULA: '2545',
    ANAL_PAP_SMEAR: '2546',
    ANOSCOPY: '2547',
    ANAL_WARTS_CONDYLOMA: '2548',
    ANAL_PAIN: '2549',
    ANAL_ITCHING: '2550',
    NEW_PATIENT_VISIT: '2551',
    ATYPIA: '2552',
    FIBROADENOMAS: '2553',
    NIPPLE_DISCHARGE: '2554',
    PSEUDOANGIOMATOUS_STROMAL_HYPERPLASIA_PASH: '2555',
    RADIAL_SCAR: '2556',
    IMAGING_FOLLOW_UP: '2557',
    BREAST_PAIN: '2558',
    BREAST_CYST: '2559',
    INTERVENTIONAL_RADIOLOGY_CONSULTATION: '2643',
    HOSPITAL_VISIT: '4048',
};

export const PROCEDURE_NAMES = {

    [PROCEDURE_IDS.ANNUAL_PHYSICAL]: 'Annual physical',
    [PROCEDURE_IDS.ANNUAL_SKIN_SCREENING]: 'Annual skin screening',
    [PROCEDURE_IDS.DENTAL_CLEANING]: 'Dental cleaning',
    [PROCEDURE_IDS.GENERAL_EYE_CONSULTATION]: 'General eye consultation',
};
